export const TK = {
  languageSelect: {
    german: 'language_select.german',
    germanAbbr: 'language_select.german_abbr',
    english: 'language_select.international',
    englishAbbr: 'common.language.english_abbr',
    czech: 'language_select.czech',
    czechAbbr: 'language_select.czech_abbr',
    french: 'language_select.french',
    frenchAbbr: 'language_select.french_abbr',
    dutch: 'language_select.dutch',
    dutchAbbr: 'language_select.dutch_abbr',
    slovakian: 'language_select.slovakian',
    slovakianAbbr: 'language_select.slovakian_abbr',
    lithuanian: 'language_select.lithuanian',
    lithuanianAbbr: 'language_select.lithuanian_abbr',
  },

  common: {
    back: 'common.back',
    next: 'common.next',
    continue: 'common.continue',
    close: 'common.close',
    edit: 'common.edit',
    length: 'common.length',
    calculatedLength: 'common.calculated_length',
    width: 'common.width',
    height: 'common.height',
    volume: 'common.volume',
    calculatedGrossVolume: 'common.calculated_gross_volume',
    calculatedNetVolume: 'common.calculated_net_volume',
    yes: 'common.yes',
    no: 'common.no',
    delete: 'common.delete',
    cancel: 'common.cancel',
    to: 'common.to',
    invalidFormat: 'common.invalid_format',
    save: 'common.save',
    search: 'common.search',
    error: 'common.error',
    createMaterialList: 'common.generate_material_list',
    infiltration: 'common.infiltration',
    detention: 'common.detention',
    treatment: 'common.treatment',
    proofOfOverflow: 'common.proof_of_overflow',
  },

  orientationMessage: 'portrait_mode_warning',

  header: {
    aboutRigoplan: 'menu_dropdown.fraenkische',
    dropdown: {
      contactPerson: 'menu_dropdown.contact_person',
      userData: 'menu_dropdown.company_data',
      aboutRigoplan: 'menu_dropdown.about',
      logout: 'menu_dropdown.logout',
    },
  },

  about: {
    heading: 'about.main_title',
    intro: {
      textSection1: 'about.fact_left',
      textSection2: 'about.fact_right',
      card1: {
        heading: 'about.why_rigoplan',
        list: {
          advantages1: 'auth.log_in.advantages_1',
          advantages2: 'auth.log_in.advantages_2',
          advantages3: 'auth.log_in.advantages_3',
          advantages4: 'auth.log_in.advantages_4',
          advantages5: 'auth.log_in.advantages_5',
        },
      },
      card2: {
        heading: 'about.tehnical_advice',
        text: 'about.need_support',
        linkText: 'about.contact_now',
      },
    },
    productOverview: {
      heading: 'about.cards.main_title',
      card1: {
        heading: 'about.cards.title_1',
        text: 'about.cards.text_1',
      },
      card2: {
        heading: 'about.cards.title_2',
        text: 'about.cards.text_2',
      },
      card3: {
        heading: 'about.cards.title_3',
        text: 'about.cards.text_3',
      },
      card4: {
        heading: 'about.cards.title_4',
        text: 'about.cards.text_4',
      },
      card5: {
        heading: 'about.cards.title_5',
        text: 'about.cards.text_5',
      },
      card6: {
        heading: 'about.cards.title_6',
        text: 'about.cards.text_6',
      },
    },
    gallery: {
      heading: 'about.gallery.main_title',
      title1: 'about.gallery.figure_title_1',
      title2: 'about.gallery.figure_title_2',
      title3: 'about.gallery.figure_title_3',
      title4: 'about.gallery.figure_title_4',
      title5: 'about.gallery.figure_title_5',
      title6: 'about.gallery.figure_title_6',
      title7: 'about.gallery.figure_title_7',
    },
    faq: {
      heading: 'about.faq.main_title',
      question1: {
        title: 'about.faq.question_1.title',
        answer: 'about.faq.question_1.p_1',
      },
      question2: {
        title: 'about.faq.question_2.title',
        answer: 'about.faq.question_2.p_1',
      },
      question3: {
        title: 'about.faq.question_3.title',
        answer1: 'about.faq.question_3.p_1',
        answer2: 'about.faq.question_3.p_2',
      },
      question4: {
        title: 'about.faq.question_4.title',
        answer1: 'about.faq.question_4.a_2',
        answer2: 'about.faq.question_4.p_2',
        answer3: 'about.faq.question_4.p_3',
        answer4: 'about.faq.question_4.a_3',
        answer5: 'about.faq.question_4.p_4',
      },
      question5: {
        title: 'about.faq.question_5.title',
        answer1: 'about.faq.question_5.a_1',
        answer2: 'about.faq.question_5.p_1',
      },
    },
  },

  footer: {
    legalNotice: 'footer.imprint',
    dataProtection: 'footer.privacy',
    termsOfUse: 'footer.general_terms_of_services',
  },

  auth: {
    login: {
      moto: 'auth.log_in.motto',
      aboutHeading: 'auth.log_in.heading',
      aboutTextSection: 'auth.log_in.continuous_text',
      aboutHeading2: 'auth.log_in.second_heading',
      aboutAdvantages1: 'auth.log_in.advantages_1',
      aboutAdvantages2: 'auth.log_in.advantages_2',
      aboutAdvantages3: 'auth.log_in.advantages_3',
      aboutAdvantages4: 'auth.log_in.advantages_4',
      aboutAdvantages5: 'auth.log_in.advantages_5',
      loginTab: 'auth.log_in.log_in',
      registerTab: 'auth.log_in.registration',
      forgotPasswordTabTitle: 'auth.log_in.forgot_password',
      forgotPasswordLink: 'auth.log_in.forgot_password',
      orDivider: 'auth.log_in.uppercase_or',
      proceedAsGuestButton: 'auth.log_in.login_as_guest',
      guestNote: 'auth.log_in.login_as_guest_description',
      registrationSuccessModalTitle:
        'auth.registration.registration_confirmation_was_sent_to_your_email_address',
      forgotPasswordSuccessModalTitle:
        'auth.forgot_password.password_reset_link_sent_to_your_email_address',
      modalOkButton: 'common.ok',
      loginForm: {
        emailLabel: 'auth.log_in.email',
        passwordLabel: 'auth.log_in.password',
        requiredFieldError: 'auth.log_in.mandatory_field',
        submitButton: 'auth.log_in.log_in',
      },
      registerForm: {
        firstNameLabel: 'auth.registration.first_name',
        lastNameLabel: 'auth.registration.last_name',
        emailLabel: 'auth.registration.email',
        passwordLabel: 'auth.registration.password',
        passwordTooltip: 'auth.registration.password_tooltip',
        repeatPasswordLabel: 'auth.registration.password_repeat',
        requiredFieldError: 'auth.log_in.mandatory_field',
        confirmAcceptance: 'auth.registration.i_accept',
        termsAndConditionsOfUse: 'auth.registration.t_o_use',
        dataPrivacyStatement: 'auth.registration.privacy_policy',
        submitButton: 'auth.log_in.registration',
        invalidPasswordError: 'auth.registration.password_validation_error',
        passwordMismatchError: 'auth.registration.invalid_password',
      },
      forgotPasswordForm: {
        emailLabel: 'auth.forgot_passowrd_init.email',
        invalidEmailFormat: 'auth.forgot_passowrd_init.invalid_format',
        submitButton: 'auth.forgot_passowrd_init.send',
        orDivider: 'auth.forgot_passowrd_init.uppercase_or',
        backButton: 'auth.forgot_passowrd_init.back',
      },
    },

    confirmRegistration: {
      success: 'auth.confrim_registration.account_validated_successfully',
      error: 'auth.confirm_registration.account_validation_failed',
      loginButton: 'auth.registration.log_in',
    },

    internalUserLogin: {
      success: 'auth.internal_user_login.account_validated_successfully',
    },

    forgotPasswordProcess: {
      title: 'auth.log_in.forgot_password',
      passwordLabel: 'auth.forgot_password.password',
      passwordTooltip: 'auth.forgot_password.password_tooltip',
      repeatPasswordLabel: 'auth.forgot_password.password_repeat',
      invalidPasswordError: 'auth.forgot_password.password_validation_error',
      passwordMismatchError: 'auth.forgot_password.invalid_password',
      sendButton: 'auth.forgot_password.send',
      orDivider: 'auth.forgot_password.uppercase_or',
      backButton: 'auth.forgot_password.back',
      modalPasswordChangedSuccessfully: 'auth.forgot_password.your_password_has_been_changed',
      modalOkButton: 'common.ok',
    },
  },

  userData: {
    heading: 'user.company_data.company_data',
    view: {
      firstNameLabel: 'user.company_data.contact_person_first_name',
      lastNameLabel: 'user.company_data.contact_person_last_name',
      salutation: {
        label: 'user.company_data.contact_person_gender',
        optionMr: 'user.company_data.gender_male',
        optionMrs: 'user.company_data.gender_female',
      },
      emailLabel: 'user.company_data.email',
      phoneLabel: 'user.company_data.phone',
      addressLabel: 'user.company_data.address',
    },
    edit: {
      companyNameLabel: 'user.company_data.form_company_name',
      firstNameLabel: 'user.company_data.form_contact_person_first_name',
      lastNameLabel: 'user.company_data.form_contact_person_last_name',
      salutation: {
        label: 'user.company_data.form_contact_person_gender',
        optionMr: 'user.company_data.gender_male',
        optionMrs: 'user.company_data.gender_female',
      },
      emailLabel: 'user.company_data.form_email',
      phoneLabel: 'user.company_data.form_phone',
      streetNumberLabel: 'user.company_data.form_address_and_street_number',
      countryLabel: 'user.company_data.form_country',
      postalCodeLabel: 'user.company_data.form_postal_code',
      cityLabel: 'user.company_data.form_city',
      requiredFieldError: 'user.company_data.mandatory_field',
      submitButton: 'user.company_data.save',
    },
  },

  companyAbout: {
    heading: 'about_rigoplan.about',
    description: 'about_rigoplan.description',
    version: 'about_rigoplan.rigoplan_version',
  },

  termsOfUse: {
    introText: 'terms_of_use.first_paragraf',
    section1: {
      heading: 'terms_of_use.point_1_title',
      textSection1: 'terms_of_use.point_1_1',
      textSection2: 'terms_of_use.point_1_2',
      textSection3: 'terms_of_use.point_1_3',
    },
    section2: {
      heading: 'terms_of_use.point_2_title',
      textSection1: 'terms_of_use.point_2_1',
      textSection2: 'terms_of_use.point_2_3',
      textSection3: 'terms_of_use.point_2_4',
      textSection4: 'terms_of_use.point_2_5',
      textSection5: 'terms_of_use.point_2_6',
      textSection6: 'terms_of_use.point_2_9',
      textSection7: 'terms_of_use.point_2_10',
    },
    section3: {
      heading: 'terms_of_use.point_3_title',
      textSection1: 'terms_of_use.point_3_1',
      textSection2: 'terms_of_use.point_3_2',
      textSection3: 'terms_of_use.point_3_3',
      textSection4: 'terms_of_use.point_3_4',
    },
    section4: {
      heading: 'terms_of_use.point_4_title',
      textSection1: 'terms_of_use.point_4_1',
      textSection2: 'terms_of_use.point_4_2',
    },
    section5: {
      heading: 'terms_of_use.point_5_title',
      textSection1: 'terms_of_use.point_5_1',
      textSection2: 'terms_of_use.point_5_2',
      textSection3: 'terms_of_use.point_5_3',
      textSection4: 'terms_of_use.point_5_4',
      textSection5: 'terms_of_use.point_5_5',
    },
    section6: {
      heading: 'terms_of_use.point_6_title',
      textSection1: 'terms_of_use.point_6',
    },
    section7: {
      heading: 'terms_of_use.point_7_title',
      textSection1: 'terms_of_use.point_7_1',
      textSection2: 'terms_of_use.point_7_2',
      textSection3: 'terms_of_use.point_7_3',
      textSection4: 'terms_of_use.point_7_4',
    },
    section8: {
      heading: 'terms_of_use.point_8_title',
      textSection1: 'terms_of_use.point_8_1',
      textSection2: 'terms_of_use.point_8_2',
    },
    section9: {
      heading: 'terms_of_use.point_9_title',
      textSection1: 'terms_of_use.point_9',
    },
    section10: {
      heading: 'terms_of_use.point_10_title',
      textSection1: 'terms_of_use.point_10_1',
      textSection2: 'terms_of_use.point_10_2',
      textSection3: 'terms_of_use.point_10_3',
      textSection4: 'terms_of_use.point_10_4',
      textSection5: 'terms_of_use.point_10_5',
      textSection6: 'terms_of_use.point_10_6',
      textSection7: 'terms_of_use.point_10_7',
      textSection8: 'terms_of_use.point_10_7_link_title',
    },
    section11: {
      heading: 'terms_of_use.point_11_title',
      textSection1: 'terms_of_use.point_11_1',
      textSection2: 'terms_of_use.point_11_2',
      textSection3: 'terms_of_use.point_11_3',
    },
    footer: 'terms_of_use.footer_paragraf',
  },

  object: {
    list: {
      heading: 'user.object.list.object_list',
      newProjectButton: 'user.object.list.new_object',
      searchLabel: 'common.search',
      table: {
        heading1: 'user.object.list.object_name',
        heading2: 'user.object.list.created',
        heading3: 'user.object.list.last_change',
      },
      deleteModalTitle: 'user.object.list.are_you_sure_you_want_to_delete_this_object',
      deleteVariationTitle: 'user.object.list.delete_variation_question',
      noEntries: 'user.object.list.no_entries',
    },
    new: {
      heading: 'user.object.new',
      form: {
        projectNameLabel: 'user.object_form.name',
        streetNumberLabel: 'user.object_form.address_and_street_number',
        countryLabel: 'user.object_form.country',
        postalCodeLabel: 'user.object_form.postal_code',
        cityLabel: 'user.object_form.city',
        alternativeEmailLabel: 'user.object_form.email',
        tooltipLabel: 'user.object_form.email_tooltip',
        commentsLabel: 'user.object_form.comment',
        requiredFieldError: 'user.object_variation.new_update.mandatory_field',
        backButton: 'user.object_form.back',
        nextButton: 'user.object_form.next',
      },
    },
    edit: {
      heading: 'user.object.edit',
    },
    copy: {
      modalTitle: 'user.object.list.do_you_want_to_copy_the_project_variant',
    },
    variation: {
      navigation: {
        projectList: 'user.menu.project_list',
        defaultSettings: 'user.menu.settings',
        basicData: 'user.menu.basic_data',
        dimensioning: 'user.menu.dimensioning',
        gak: 'user.menu.gpm',
        materialList: 'user.menu.material_list',
        treatment: 'user.menu.treatment',
        proofOfOverflow: 'user.menu.proof_of_overflow',
      },
      changeFlowConfirmModalText: 'user.object_variation.new_update.change_flow_warning',
      /** `86407` - question before the configuration of a treatment is closed (legacy). */
      allInputWillBeRemovedContinueAnyway: 'expert.all_input_will_be_removed_continue_anyway',
      new: {
        heading: 'user.object_variation.new_update.configuration_of_object_planning',
        subheading1: 'user.object_variation.new_update.please_name_the_planning_process',
        tooltipLabel: 'user.object_variation.new_update.with_the_help_of_the_project_variants',
        projectVariantLabel: 'user.object_variation.new_update.name_of_planning_process',
        requiredFieldError: 'user.object_variation.new_update.please_name_the_planning_process',
        renameButton: 'user.object_variation.new_update.rename',
        subheading2: 'user.object_variation.new_update.choose_method_for_planning',
        mwodCard: {
          heading: 'user.object_variation.new_update.material_list_creation_without_dimensioning',
          startButton: 'user.object_variation.new_update.start_mwod',
          tooltipLabel: 'user.object_variation.new_update.use_this_mode_to_map_a_known_volume',
        },
        dimensioningModeCard: {
          heading: 'user.object_variation.new_update.material_list_creation_with_dimensioning',
          expertModeButton: 'user.object_variation.new_update.expert_mode',
          tooltipExpertLabel:
            'user.object_variation.new_update.use_this_mode_to_dimension_and_design',
          quickAndEasyButton: 'user.object_variation.new_update.quick_and_easy',
          tooltipQuickAndEasyLabel: 'user.object_variation.new_update.quick_and_easy_tooltip',
        },
        backButton: 'user.object_variation.new_update.back',
      },

      createSubsystemModal: {
        heading: 'user.object_variation.material_list_edit.header',
        subsystemLabel: 'user.object_variation.material_list_edit.input_label',
        subsystemValue: 'user.object_variation.material_list.subsystem',
        requiredFieldError: 'user.object_variation.material_list.required_field',
        nextButton: 'user.object_variation.material_list_edit.button',
      },

      materialList: {
        subsystem: 'user.object_variation.material_list.subsystem',
        editSubsystem: 'user.object_variation.material_list_edit.header',
        addItem: 'user.object_variation.material_list.add_article',
        addItemsHeading: 'user.object_variation.material_list.add_new_articles',
        availableProducts: 'user.object_variation.material_list.available',
        selectedProducts: 'user.object_variation.material_list.picked',
        noSearchResults: 'user.object_variation.material_list.no_results',
        noSelectedProducts: 'user.object_variation.material_list.no_picked_articles',
        selectAvailableProduct: 'user.object_variation.material_list.select_available_article',
        selectSelectedProduct: 'user.object_variation.material_list.select_picked_article',
        pickProduct: 'user.object_variation.material_list.pick_article',
        updateProduct: 'user.object_variation.material_list.update_article',
        addToMaterialList: 'user.object_variation.material_list.add_to_material_list',
        addProductsError: 'user.object_variation.material_list.add_products_error',
        optional: 'user.object_variation.material_list.optional',
        image: 'user.object_variation.material_list.image',
        articleDescription: 'user.object_variation.material_list.article_description',
        overview: 'user.object_variation.material_list.overview',
        date: 'user.object_variation.material_list.date',
        sum: 'user.object_variation.material_list.sum',
        editManually: 'user.object_variation.material_list.activate_editing_of_the_material_list',
        editManuallyConfirm:
          'user.object_variation.material_list.do_you_want_to_activate_manual_processing_of_the_material_list',
        saveChanges: 'user.object_variation.material_list.deactivate_editing_of_the_material_list',
        rejectChanges: 'user.object_variation.material_list.discard_changes',
        rejectChangesConfirm:
          'user.object_variation.material_list.do_you_wish_to_discard_your_changes_and_return_to_the_original_materials_list',
        removeItem: 'user.object_variation.material_list.remove_article',
        removeItemConfirm:
          'user.object_variation.material_list.do_you_want_to_delete_the_selected_item_permanently',
        quantityRequired:
          'user.object_variation.material_list.please_complete_the_quantity_entry_for_article',
        addSubsystem: 'user.object_variation.material_list.add_subsystem',
        tenderTexts: 'user.object_variation.material_list.export.export_material_list',
        dimensioningReportPdf: 'user.object_variation.material_list.export_pdf_button',
        comingSoon: 'user.object_variation.material_list.coming_soon',
        addSubsystemError: 'user.object_variation.material_list.add_subsystem_error',
        positionNumber: 'user.object_variation.material_list.position_number',
        article: 'user.object_variation.material_list.article',
        articleNumber: 'user.object_variation.material_list.article_number',
        quantity: 'user.object_variation.material_list.quantity',
        unit: 'user.object_variation.material_list.unit',
        unitPrice: 'user.object_variation.material_list.unit_price',
        totalPrice: 'user.object_variation.material_list.total_price',
        priceOnRequest: 'user.object_variation.material_list.price_on_request',
        noProductsNeeded: 'user.object_variation.material_list.no_frankische_products_needed',
        loadError: 'user.object_variation.material_list.load_error',
        renameError: 'user.object_variation.material_list.rename_error',
        retry: 'user.object_variation.material_list.retry',
        alternativeItem: 'user.object_variation.material_list.alternative_article',
        replaceHeading: 'user.object_variation.material_list.replace_article',
        applySelectedItem: 'user.object_variation.material_list.apply_selected_item',
        backWithoutChange: 'user.object_variation.material_list.back_without_change',
        replaceError: 'user.object_variation.material_list.replace_error',
        comment: 'user.object_variation.material_list.comment',
        saveComment: 'user.object_variation.material_list.save_comment',
        saveCommentError: 'user.object_variation.material_list.save_comment_error',
        tenderTextsModal: {
          title: 'user.object_variation.material_list.export.title',
          titleMobile: 'user.object_variation.material_list.export.title_mobile',
          submit: 'user.object_variation.material_list.export.email',
          submitSuccess: 'user.object_variation.material_list.export.email_success',
          submitError: 'user.object_variation.material_list.export.email_error',
          gaeb81: 'user.object_variation.material_list.export.gaeb_81',
          gaeb81Small: 'user.object_variation.material_list.export.gaeb_81_small',
          gaeb81Info: 'user.object_variation.material_list.export.gaeb_81_info',
          gaeb82: 'user.object_variation.material_list.export.gaeb_82',
          gaeb82Small: 'user.object_variation.material_list.export.gaeb_82_small',
          gaeb82Info: 'user.object_variation.material_list.export.gaeb_82_info',
          gaeb83: 'user.object_variation.material_list.export.gaeb_83',
          gaeb83Info: 'user.object_variation.material_list.export.gaeb_83_info',
          schatzLv: 'user.object_variation.material_list.export.schatz_lv',
          schatzLvDescription: 'user.object_variation.material_list.export.schatz_lv_description',
          angebotsaufforderung: 'user.object_variation.material_list.export.angebotsaufforderung',
          angebotsaufforderungDescription:
            'user.object_variation.material_list.export.angebotsaufforderung_description',
        },
        dimensioningReportModal: {
          title: 'user.object_variation.material_list.content_of_the_design_report',
          basicData: 'user.object_variation.material_list_export_pdf.basic_data',
          materialList: 'user.object_variation.material_list_export_pdf.material_list',
          gpm: 'user.object_variation.material_list_export_pdf.gpm',
          detailedMaterialList:
            'user.object_variation.material_list_export_pdf.material_list_detailed',
          submit: 'user.object_variation.material_list_export_pdf.export_pdf',
          submitSuccess: 'user.object_variation.material_list.export_pdf_email_success',
          submitError: 'user.object_variation.material_list.export_pdf_email_error',
        },
      },

      mwod: {
        heading: 'mwod.object_planning_without_dimensioning',
        reverseModalTitle: 'mwod.all_input_will_be_removed_continue_anyway',
        addSystem: 'mwod.add_system',
        baseCalculationOption: {
          heading: 'mwod.select_one_of_following_options',
          storageVolumeWithAdditionalComponents: 'mwod.storage_volume_with_additions',
          stormwaterTreatment: 'mwod.stormwater_treatment_without_storage_volume',
          dischargeControl: 'mwod.discharge_control_without_storage_volume',
        },
        stormwaterTreatment: {
          heading: 'mwod.stormwater_treatment.please_select_one_or_more_following_systems',
          selectedNumberOfSystems: 'mwod.stormwater_treatment.selected_number_of_systems',
          clear: 'mwod.stormwater_treatment.clear',
          pleaseChooseInletOutletDimensions:
            'mwod.stormwater_treatment.please_choose_appropriate_inlet_and_outlet_dimensions',
          pleaseChooseSewerDepth: 'mwod.stormwater_treatment.please_choose_appropriate_sewer_depth',
          sewerDepthLessThan2_5m: 'mwod.stormwater_treatment.sewer_depth_less_then_2_5m',
          sewerDepthMoreThan2_5m: 'mwod.stormwater_treatment.sewer_depth_more_then_2_5m',
          pleaseChooseShaftCoverType:
            'mwod.stormwater_treatment.please_choose_appropriate_shaft_cover_type',
          shaftCoverTypePopup: {
            page1: 'info_pop_up_2_11_1',
            page2: 'info_pop_up_2_11_2',
          },
          withShaftCone: 'mwod.stormwater_treatment.with_shaft_cone',
          withConcreteCoverPlateShallowDepth:
            'mwod.stormwater_treatment.with_concrete_cover_plate_shallow_depth',
          straight180: 'mwod.stormwater_treatment.straight_180',
          right270: 'mwod.stormwater_treatment.right_270',
          left90: 'mwod.stormwater_treatment.left_90',
          pleaseChooseFlowDirectionOfTargetShaft:
            'mwod.stormwater_treatment.please_choose_appropriate_flow_direction_of_target_shaft',
          inletOutlet: {
            io1: 'mwod.stormwater_treatment.IO1_Inlet_1x_DN_200_Outlet_1x_DN_200',
            io2: 'mwod.stormwater_treatment.IO2_Inlet_1x_DN_250_Outlet_1x_DN_250',
            io3: 'mwod.stormwater_treatment.IO3_Inlet_1x_DN_315_Outlet_1x_DN_315',
            io1L: 'mwod.stormwater_treatment.inlet_1x_dn315_outlet_1x_dn315',
            io2L: 'mwod.stormwater_treatment.inlet_1x_dn400_outlet_1x_dn400',
            io3L: 'mwod.stormwater_treatment.inlet_1x_dn400_2x_dn315_outlet_1x_dn400',
            io1Pipe: 'mwod.stormwater_treatment.inlet_1x_dn400_outlet_1x_dn400',
            io2Pipe: 'mwod.stormwater_treatment.inlet_2x_dn400_outlet_1x_dn400',
            io3Pipe: 'mwod.stormwater_treatment.inlet_1x_dn400_2x_dn315_outlet_1x_dn400',
            dnOd200: 'mwod.stormwater_treatment.DN_OD_200',
            dnOd250: 'mwod.stormwater_treatment.DN_OD_250',
            dnOd315: 'mwod.stormwater_treatment.DN_OD_315',
            dnOd400: 'mwod.stormwater_treatment.DN_OD_400',
            dnOd500: 'mwod.stormwater_treatment.DN_OD_500',
          },
          products: {
            rigoclean500WithLateralInlet:
              'mwod.stormwater_treatment.rigoclean_500_with_lateral_inlet',
            rigoclean500WithUpperInlet: 'mwod.stormwater_treatment.rigoclean_500_with_upper_inlet',
            rigoclean1000WithLateralInlet:
              'mwod.stormwater_treatment.rigoclean_1000_with_lateral_inlet',
          },
          flow: {
            rigoClean: 'mwod.stormwater_treatment.rigo_clean',
            rigoCleanPopup: 'info_pop_up_2_1',
            sediPoint: 'mwod.stormwater_treatment.sedi_point',
            sediPointPopup: 'info_pop_up_2_2',
            sediPipeLevel: 'mwod.stormwater_treatment.sedi_pipe_level',
            sediPipeLevelPopup: 'info_pop_up_2_3',
            sediPipeL: 'mwod.stormwater_treatment.sedi_pipe_l',
            sediPipeLPopup: 'info_pop_up_2_4',
            sediPipeLPlus: 'mwod.stormwater_treatment.sedi_pipe_l_plus',
            sediPipeLPlusPopup: 'info_pop_up_2_6',
            sediPipeXL: 'mwod.stormwater_treatment.sedi_pipe_xl',
            sediPipeXLPopup: 'info_pop_up_2_5',
            sediPipeXLPlus: 'mwod.stormwater_treatment.sedi_pipe_xl_plus',
            sediPipeXLPlusPopup: 'info_pop_up_2_7',
            sediPipe800: 'mwod.stormwater_treatment.sedi_pipe',
            sediPipe800Popup: 'info_pop_up_2_13',
            sediPipe800Plus: 'mwod.stormwater_treatment.sedi_pipe_plus',
            sediPipe800PlusPopup: 'info_pop_up_2_14',
            sediSubstratorBasic: 'mwod.stormwater_treatment.sedisubstrator_basic',
            sediSubstratorBasicPopup: 'info_pop_up_2_8',
            sediSubstratorL: 'mwod.stormwater_treatment.sedisubstrator_l',
            sediSubstratorLPopup: 'info_pop_up_2_9',
            sediSubstratorLEco: 'mwod.stormwater_treatment.sedisubstrator_l_eco',
            sediSubstratorLEcoPopup: 'info_pop_up_2_17',
            sediSubstratorXL: 'mwod.stormwater_treatment.sedisubstrator_xl',
            sediSubstratorXLPopup: 'info_pop_up_2_10',
            sediSubstratorXLEco: 'mwod.stormwater_treatment.sedisubstrator_xl_eco',
            sediSubstratorXLEcoPopup: 'info_pop_up_2_18',
          },
        },
        systemTypeOption: {
          heading: 'mwod.system_type.please_choose_system_type',
          infiltration: 'mwod.system_type.infiltration',
          stormWaterDetention: 'mwod.system_type.storm_water_detention',
          stormWaterHarvesting: 'mwod.system_type.storm_water_harvesting',
          extinguishingWaterStorage: 'mwod.system_type.extinguishing_water_storage',
        },
        infiltrationSystemOption: {
          heading: 'mwod.choose_infiltration_system',
          rigoFillBlocks: 'mwod.infiltration_with_rigofill_blocks',
          pipeSwales: 'mwod.infiltration_with_pipe_swales',
          popup: {
            rigoFillBlocks: 'info_pop_up_3_11',
            pipeSwales: 'info_pop_up_3_10',
          },
        },
        pipeSwaleType: {
          heading: 'mwod.please_choose_a_swale_type',
          swaleSickuPipeOption: 'mwod.infiltration_via_pipe_swale_sicku_pipe',
          swaleMuriPipeOption: 'mwod.infiltration_via_underdrained_swale_muri_pipe',
          popup: {
            sickuPipe: 'info_pop_up_3_4',
            muriPipe: 'info_pop_up_3_12',
          },
        },
        pipeSwaleDimensions: {
          heading: 'mwod.dimensions_of_infiltration_ditch',
          subHeading: 'mwod.ditch_dimensions',
          resultsHeading: 'mwod.input_results_in_ditch_volume',
          lengthPlaceholder: 'common.length_in_meters',
          widthPlaceholder: 'mwod.width_in_meters',
          heightPlaceholder: 'mwod.height_in_meters',
          gravelStorageCoefficient: 'mwod.storage_coefficient_of_gravel',
          recommendedNumberOfPipeLines: 'mwod.recommended_number_of_pipe_lines',
          selectedNumberOfPipeLines: 'mwod.selected_number_of_pipe_lines',
          maxNumberOfPipeLinesTooltip: 'mwod.maximum_number_of_pipe_lines_was_reached',
        },
        blockTypeOption: {
          heading: 'mwod.choose_rigofill_blocks',
          rigofillSTS: 'Rigofill ST-S',
          rigofillSTA: 'Rigofill ST-A',
          rigofillInspect: 'Rigofill inspect',
          rigofillInspectObsolete: 'Rigofill inspect obsolete',
          rigofillSTVHL: 'Rigofill ST-VHL',
          selectedText: {
            rigofillSTS: 'expert.dimensioning_workflow_option.rigofil_inspect_sts_data',
            rigofillSTA: 'expert.dimensioning_workflow_option.rigofil_inspect_sta_data',
            rigofillInspect: 'expert.dimensioning_workflow_option.rigofil_inspect_new_data',
          },
          popup: {
            rigofillSTS: 'info_pop_up_3_20',
            rigofillSTA: 'info_pop_up_3_19',
            rigofillInspect: 'info_pop_up_3_18',
            rigofillInspectObsolete: 'info_pop_up_3_1',
          },
        },
        swdSystemOption: {
          heading: 'mwod.swd_please_choose_system_type',
          topTubModelOption: 'mwod.stormwater_detention_basin_open_on_top_tub_model',
          tankModelOption: 'mwod.stormwater_detention_basin_tank_model_add_cone',
          popup: {
            topTubModelOption: 'info_pop_up_3_16',
            tankModelOption: 'info_pop_up_3_17',
          },
        },
        waterStorageOption: {
          heading: 'mwod.please_choose_system_type',
          topTubModelOption: 'mwod.tub_model_open_on_top',
          tankModelOption: 'mwod.tank_model_sealed_up_to_upper_edge_of_terrain',
          popup: {
            topTubModelOption: 'info_pop_up_3_16',
            tankModelOption: 'info_pop_up_3_17',
          },
        },
        ditchDimensioning: {
          heading: 'mwod.ditch_dimensions_title',
          subHeading: 'mwod.ditch_dimensions',
          dimensionsKnownQuestion: 'mwod.are_dimensions_of_infiltraion_ditch_known',
          storageVolume: 'mwod.storage_volume',
          resultsHeading: 'mwod.input_results_in_ditch_volume',
          grossVolume: 'mwod.gross_volume',
          netVolume: 'mwod.net_volume',
          requiredStorageVolume: 'mwod.ditch_dimensions.required_storage_volum',
          freeboardTooltip: 'mwod.freeboard_100mm_complying_with_din14230',
          lengthPlaceholder: 'common.length_in_meters',
          widthPlaceholder: 'mwod.width_in_meters',
          heightPlaceholder: 'mwod.height_in_meters',
        },
        controlShafts: {
          heading: 'mwod.selection_of_control_shafts',
          quadroControl: 'mwod.quadro_control',
          rigoControl: 'expert.control_shafts.rigocontrol',
          recommendedNumberOfShafts: 'mwod.recommended_number_of_control_shafts',
          selectedNumberOfShafts: 'mwod.selected_number_of_control_shafts',
          frontSideShafts: 'mwod.thereof_frontal',
          recommendedNumberTooltip: 'mwod.selection_of_control_shafts_rigofill_blocks_tooltip',
          maxNumberOfShaftsTooltip: 'mwod.maximum_allowed_number_of_control_shafts_reached',
          maxNumberOfFrontalShaftsTooltip: 'mwod.maximum_allowed_number_of_frontal_shafts_reached',
          popup: {
            quadroControl: 'info_pop_up_3_7',
            rigoControl: 'info_pop_up_3_9',
          },
        },
        switchToStormwaterTreatmentFlow: {
          heading: 'mwod.stormwater_treatment',
          subHeading: 'mwod.do_you_want_to_add_storm_water_treatment',
        },
        switchToDischargeControlFlow: {
          heading: 'mwod.discharge_control',
          subHeading: 'mwod.do_you_want_to_add_discharge_control',
        },
        dischargeControl: {
          heading: 'mwod.discharge_control.please_choose_discharge_control_shaft_type',
          options: {
            quadroLimit: 'mwod.discharge_control.quadro_limit',
            aquaLimit: 'mwod.discharge_control.aqua_limit',
            aquaLimitTube: 'mwod.discharge_control.aqua_limit_tube',
            rigoLimitV: 'mwod.discharge_control.rigo_limit_v',
          },
          popup: {
            quadroLimit: {
              page1: 'info_pop_up_4_2_1',
              page2: 'info_pop_up_4_2_2',
              page3: 'info_pop_up_4_2_3',
            },
            aquaLimit: {
              page1: 'info_pop_up_4_3_1',
              page2: 'info_pop_up_4_3_2',
              page3: 'info_pop_up_4_3_4',
            },
            aquaLimitTube: {
              page1: 'info_pop_up_4_1_1',
              page2: 'info_pop_up_4_1_2',
              page3: 'info_pop_up_4_1_4',
            },
            rigoLimitV: {
              page1: 'info_pop_up_4_4_1',
              page2: 'info_pop_up_4_4_2',
              page3: 'info_pop_up_4_4_4',
            },
          },
          maxAllowedFlow: 'mwod.discharge_control.please_enter_maximum_allowed_flow',
          maxAllowedFlowLabel: 'mwod.discharge_control.please_enter_maximum_allowed_flow_label',
          maxRetainableHeight: 'mwod.discharge_control.please_enter_maximal_retainable_height',
          maxRetainableHeightLabel:
            'mwod.discharge_control.please_enter_maximal_retainable_height_label',
          averageFlow: 'mwod.discharge_control.average_flow',
          averageFlowLabel: 'mwod.discharge_control.average_flow_label',
          throttleType: 'expert.system_specifications.internal_useer_throttle_type',
          outletDimension: 'expert.system_specifications.internal_user_outlet_dimensions',
          outsideOfSpecification: 'mwod.discharge_control.outside_of_specification',
          pleaseChooseDifferentProductOrAdjustInput:
            'mwod.discharge_control.please_choose_different_product_or_adjust_input',
          addAnotherSystemQuestion:
            'mwod.discharge_control.do_you_want_to_add_another_discharge_control_system',
        },
        additionalOverflow: {
          heading: 'mwod.additional_overflow',
          subheading: 'mwod.additional_overflow.do_you_want_to_select_an_overflow_as_well',
          selectOverflow: 'mwod.additional_overflow.please_select_an_overflow',
          quadroOverflowOption: 'mwod.system_specifications.quadro_overflow',
          popup: {
            quadroOverflow: 'info_pop_up_4_6_1',
          },
        },
        checkValue: {
          heading: 'mwod.additional_check_value',
          subheading: 'mwod.additional_check_value.do_you_need_a_check_value',
          selectCheckValue: 'mwod.additional_check_value.please_select_check_value',
          aquaBackStopOption: 'mwod.system_specifications.aqua_backstop',
          popup: {
            quadroOverflow: 'info_pop_up_4_5_1',
          },
        },
        graphicalModuleButton: 'mwod.continue_to_gpm',
        materialListButton: 'mwod.material_list',
      },
      expert: {
        expertDimensioningType: {
          heading: 'expert.dimensioning.please_choose_dimensioning_type',
          stormwaterInfiltrationDWAA138October2024:
            'expert.dimensioning.rainwater_infiltration_with_optional_treatment_and_optional_proof_of_overflow',
          stormwaterInfiltrationDWAA138October2024Tooltip:
            'expert.dimensioning.rainwater_infiltration_with_optional_treatment_and_optional_proof_of_overflow_tooltip',
          stormwaterInfiltrationDWAA138October2024QuickAndEasy:
            'expert.dimensioning.rainwater_infiltration_quick_and_easy',
          stormwaterInfiltrationDWAA138October2024QuickAndEasyTooltip:
            'expert.dimensioning.rainwater_infiltration_with_optional_treatment_and_optional_proof_of_overflow_tooltip_quick_and_easy',
          stormwaterRetention:
            'expert.dimensioning.detention_with_optional_treatment_and_optional_proof_of_overflow',
          stormwaterRetentionTooltip:
            'expert.dimensioning.detention_with_optional_treatment_and_optional_proof_of_overflow_tooltip',
          stormwaterRetentionQuickAndEasy: 'expert.dimensioning.detention_quick_and_easy',
          stormwaterRetentionQuickAndEasyTooltip:
            'expert.dimensioning.detention_with_optional_treatment_and_optional_proof_of_overflow_tooltip_quick_and_easy',
          stormwaterInfiltrationDWAA138April2005:
            'expert.dimensioning.infiltration_with_optional_treatment_and_optional_proof_of_overflow',
          stormwaterInfiltrationDWAA138April2005Tooltip:
            'expert.dimensioning.infiltration_with_optional_treatment_and_optional_proof_of_overflow_tooltip',
          stormwaterInfiltrationDWAA138April2005QuickAndEasy:
            'expert.dimensioning.infiltration_quick_and_easy',
          stormwaterInfiltrationDWAA138April2005QuickAndEasyTooltip:
            'expert.dimensioning.infiltration_with_optional_treatment_and_optional_proof_of_overflow_tooltip_quick_and_easy',
          stormwaterTreatment: 'expert.dimensioning.treatment_without_storage_volume',
          stormwaterTreatmentTooltip:
            'expert.dimensioning.treatment_without_storage_volume_germany_tooltip',
          stormwaterTreatmentQuickAndEasy: 'expert.dimensioning.treatment_quick_and_easy',
          stormwaterTreatmentQuickAndEasyTooltip:
            'expert.dimensioning.treatment_without_storage_volume_germany_tooltip_quick_and_easy',
          proofOfOverflow: 'expert.dimensioning.proof_of_overflow',
          proofOfOverflowTooltip: 'expert.dimensioning.proof_of_overflow_tooltip',
          proofOfOverflowQuickAndEasy: 'expert.dimensioning.proof_of_overflow_quick_and_easy',
          proofOfOverflowQuickAndEasyTooltip:
            'expert.dimensioning.proof_of_overflow_tooltip_quick_and_easy',
        },
        rainData: {
          heading: 'expert.rain_data.rain_data',
          version2020: 'expert.rain_data_table.use_localized_kostra_data_2020',
          version2010R9: 'expert.rain_data_table.use_localized_kostra_data',
          ownSeries: 'expert.rain_data_table.define_own_rain_data_series',
          upload: 'expert.rain_data_table.use_kostra_data',
          modelFromSoftware: 'expert.rain_data_table.default_rain_data_series',
        },
        rainDataTable: {
          loadRainSeries: 'expert.rain_data_table.load_rain_data',
          invalidCoordinates: 'expert.rain_data_table.invalid_coordinates',
          unableToGetCoordinates:
            'expert.rain_data_table.unable_to_get_coordinates_from_object_address',
          switchUnits: 'expert.rain_data.switch_units',
          rows: 'expert.rain_data.rows',
          columns: 'expert.rain_data.columns',
          importDataFromFile: 'expert.rain_data.import_data_from_file',
          exportDataToFile: 'expert.rain_data.export_data_to_file',
          exportOwnRainDataTitle: 'expert.rain_data_table.export_own_rain_data_title',
          exportOwnRainDataFilename: 'expert.rain_data_table.export_own_rain_data_filename',
          exportOwnRainDataInvalidFilename:
            'expert.rain_data_table.export_own_rain_data_invalid_filename',
          pleaseFillMandatoryFields: 'expert_mode.rain_data_table.please_fill_mandatory_fields',
          gridColumn: 'expert.rain_data_table.grid_column',
          gridRow: 'expert.rain_data_table.grid_row',
          location: 'expert.rain_data_table.location',
          years: 'common.years',
          shouldConsiderClimateFactor:
            'expert.rain_data_table.should_a_climate_change_factor_be_taken_into_account',
          climateFactorTooltip: 'expert.rain_data_table.climate_change_factor_tooltip',
          informationOnClimateFactor:
            'expert.rain_data_table.information_on_the_climate_change_factor',
          climateChangeFactor: 'expert.rain_data_table.climate_change_factor',
          climateChangeFactorInputTooltip:
            'expert.rain_data_table.climate_change_factor_input_tooltip',
          atWhatAnnuality:
            'expert.rain_data_table.at_what_annuality_t_should_the_climate_change_factor_be_taken_into_account',
          annualityT: 'expert.rain_data_table.annuality_t',
        },
        subsystemsAndAreas: {
          heading: 'expert.subystem_and_areas.definition_of_subystems_and_areas',
          areaSelection: 'expert.subsystem_and_areas.area_selection',
          subsystem: 'expert.subystems_and_areas.subsystem',
          subsystemName: 'expert.subystems_and_areas.subsystem_name',
          wholeAreaHeading: 'expert.subystem_and_areas.whole_area_heading',
          wholeAreaAeHeading: 'expert.subystem_and_areas.whole_area_ae_heading',
          peakRunoffCoefficient: 'expert.run_off_coefficient_proof_of_overflow',
          areaSumHeading: 'expert.subystem_and_areas.area_sum_heading',
          areaSumAcHeading: 'expert.subystem_and_areas.area_sum_ac_heading',
          infiltration: 'expert.subystems_and_areas.infiltration',
          detention: 'expert.subystems_and_areas.detention',
          treatment: 'expert.subystems_and_areas.treatment',
          proofOfOverflow: 'expert.subystems_and_areas.proof_of_overflow',
          addSubsystem: 'expert.subystems_and_areas.add_subsystem',
          yourInputResults: 'expert.subystem_and_areas.your_input_results',
          wholeArea: 'expert.subystem_and_areas.whole_area',
          wholeAreaImpenetrable: 'expert.subystem_and_areas.whole_area_impenetrable',
          totalConnectableSubarea: 'expert.subystem_and_areas.total_conected_area',
          reducedAreaCalculationValue: 'expert.subystem_and_areas.calculated_reduced_area_value',
          meanDischargeCoefficient: 'expert.subsystem_and_areas.average_discharge_coefficient',
          cs: 'expert.subsystem_and_areas.cs',
          flowRate: 'expert.subsystem_and_areas.flow_rate',
          deleteSubsystem: 'user.object_variation.material_list.delete_subsystem',
          deleteSubsystemConfirmMessage: 'expert.subystem_and_areas.modal_message',
          noEntries: 'expert.subystems_and_areas.no_entries',
          areaName: 'expert.subystems_and_areas.area_name',
          areaType: 'expert.subystems_and_areas.area_type',
          areaSize: 'expert.subystems_and_areas.area_size',
          quickAndEasyAreaTooltip: 'expert.subystems_and_areas.quick_and_easy_area_tooltip',
          connectedArea: 'expert.subystems_and_areas.total_area',
          dischargeCoefficient: 'expert.subystems_and_areas.run_off_coefficient',
          save: 'expert.subystems_and_areas.save',
          startDimensioning: 'expert.subsystem_and_areas.start_dimensioning',
          areaSaveConfirmMessage:
            'expert.subystem_and_areas.do_you_want_to_save_the_new_area_information_your_previously_made_calculations_are_being_reset',
          quickAndEasyAreaTypes: {
            pitchedRoof: 'expert.subystem_and_areas.qa_area_type_pitched_roof',
            flatRoof: 'expert.subystem_and_areas.qa_area_type_flat_roof',
            greenRoof: 'expert.subystem_and_areas.qa_area_type_green_roof',
            concreteSurface: 'expert.subystem_and_areas.qa_area_type_asphalt_concrete_surface',
            pavedSurface: 'expert.subystem_and_areas.qa_area_type_asphalt_paved_surface',
            gravelSurface: 'expert.subystem_and_areas.qa_area_type_gravel_gravel_surface',
            greenSurface: 'expert.subystem_and_areas.qa_area_type_green_area',
          },
          coefficientTable: {
            heading: 'expert.subystem_and_areas.table_of_discharge_coefficients',
            headerIntro:
              'expert.subystem_and_areas.tfdc.discharge_coefficients_of_the_area_to_be_drained_according_to',
            dwaA138: 'expert.subystem_and_areas.tfdc.DWA_A_138_A_117_M 153',
            din1986: 'expert.subystem_and_areas.tfdc.DIN_1986_100',
            recommendation: 'expert.subystem_and_areas.tfdc.recomendation',
            areaType: 'expert.subystem_and_areas.tfdc.area_type',
            typeOfFixation: 'expert.subystem_and_areas.tfdc.type_of_fixation',
            dischargeCoefficient: 'expert.subystem_and_areas.tfdc.discharge_coefficient',
            pitchedRoof: 'expert.subystem_and_areas.tfdc.pitched_roof',
            metalGlassSlateFibreCement:
              'expert.subystem_and_areas.tfdc.metal_glass_slate_fibre_cement',
            tilesRoofingFelt: 'expert.subystem_and_areas.tfdc.tiles_roofing_felt',
            flatRoof: 'expert.subystem_and_areas.tfdc.flat_roof',
            metalGlassFibreCement: 'expert.subystem_and_areas.tfdc.metal_glass_fibre_cement',
            roofingFelt: 'expert.subystem_and_areas.tfdc.roofing_felt',
            gravel: 'expert.subystem_and_areas.tfdc.gravel',
            greenRoof: 'expert.subystem_and_areas.tfdc.green_roof',
            intensiveGreening: 'expert.subystem_and_areas.tfdc.intensive_greening',
            humusLess10cm: 'expert.subystem_and_areas.tfdc.humus_less_then_10_cm',
            humusMore10cm: 'expert.subystem_and_areas.tfdc.humus_larger_then_10_cm',
            roadsPathsSquaresFlat: 'expert.subystem_and_areas.tfdc.roads_paths_squares_flat',
            asphaltJointlessConcrete: 'expert.subystem_and_areas.tfdc.asphalt_jointless_concrete',
            ramps: 'expert.subystem_and_areas.tfdc.ramps',
            pavementWithTightJoints: 'expert.subystem_and_areas.tfdc.pavement_with_tight_joints',
            concreteBlockPavingSandSlag:
              'expert.subystem_and_areas.tfdc.concrete_block_paving_laid_in_sand_or_slag',
            solidGravelSurface: 'expert.subystem_and_areas.tfdc.solid_gravel_surface',
            pavementWithOpenJoints: 'expert.subystem_and_areas.tfdc.pavement_with_open_joints',
            looseGravelSurfaceGravelLawn:
              'expert.subystem_and_areas.tfdc.loose_gravel_surface_gravel_lawn',
            playgroundsPartiallyPaved:
              'expert.subystem_and_areas.tfdc.children_playgrounds_with_partial_fastenings',
            interlockingPaversSeepage:
              'expert.subystem_and_areas.tfdc.interlocking_pavers_with_joints_seepage_stones',
            lawnGridStones: 'expert.subystem_and_areas.tfdc.lawn_grid_stones',
            embankmentsBanquetsDitches:
              'expert.subystem_and_areas.tfdc.embankments_banquets_and_ditches',
            clayeySoil: 'expert.subystem_and_areas.tfdc.clayey_soil',
            loamySandySoil: 'expert.subystem_and_areas.tfdc.loamy_sandy_soil',
            gravelAndSandSoil: 'expert.subystem_and_areas.tfdc.gravel_and_sand_soil',
            gardensMeadowsCultivated:
              'expert.subystem_and_areas.tfdc.gardens_meadows_and_cultivated_land',
            flatTerrain: 'expert.subystem_and_areas.tfdc.flat_terain',
            steepTerrain: 'expert.subystem_and_areas.tfdc.stoiles_terain',
            sportsWithDrainage: 'expert.subystem_and_areas.tfdc.sports_bottle_with_dranung',
            syntheticSurfacesTurf:
              'expert.subystem_and_areas.tfdc.synthetic_surfaces_synthetic_turf',
            barnFloors: 'expert.subystem_and_areas.tfdc.barn_floors',
            lawnAreas: 'expert.subystem_and_areas.tfdc.lawn_areas',
            t5TypeOfSurface: 'expert.subystem_and_areas.table.type_of_surface_or_its_fastening',
            t5AverageCoefficient: 'expert.subystem_and_areas.table.average_runoff_coefficient_cm',
            t5AverageCoefficientCs: 'expert.subystem_and_areas.table.average_runoff_coefficient_cs',
            t5WaterproofSurface: 'expert.subystem_and_areas.table.waterproof_surface',
            t5RoofSurface: 'expert.subystem_and_areas.table.roof_surface',
            t5PitchedRoof: 'expert.subystem_and_areas.table.pitched_roof',
            t5MetalGlassSlateFibre:
              'expert.subystem_and_areas.table.metal_glass_slate_fiber_cement',
            t5BricksWaterproofing: 'expert.subystem_and_areas.table.bricks_waterproofing_membranes',
            t5FlatRoof:
              'expert.subystem_and_areas.table.flat_roof_up_to_5_degree_or_aprox_5_percent',
            t5MetalGlassFibre: 'expert.subystem_and_areas.table.metal_glass_fiber_cement',
            t5GravelFilling: 'expert.subystem_and_areas.table.gravel_filling',
            t5GreenRoof: 'expert.subystem_and_areas.table.green_roof',
            t5ExtensiveGreening: 'expert.subystem_and_areas.table.extensive_greening',
            t5MoreThan5Degree: 'expert.subystem_and_areas.table.more_than_5_degree',
            t5IntensiveGreening30:
              'expert.subystem_and_areas.table.intensive_greening_more_or_equal_than_30cm_construction_thickness',
            t5LessThan5Degree: 'expert.subystem_and_areas.table.less_than_or_equal_to_5_degree',
            t5ExtensiveGreening10:
              'expert.subystem_and_areas.table.extensive_greening_greater_than_or_equal_to_10cm_construction_thickness',
            t5ExtensiveGreeningLess10:
              'expert.subystem_and_areas.table.extensive_greening_less_than_10cm_construction_thickness',
            t5TrafficAreas:
              'expert.subystem_and_areas.table.traffic_areas_roads_squares_driveways_paths_railway_tracks',
            t5ConcreteSurface: 'expert.subystem_and_areas.table.concrete_surface',
            t5Asphalt: 'expert.subystem_and_areas.table.bituminous pavement_asphalt',
            t5PavedTightJoints:
              'expert.subystem_and_areas.table.paved_surfaces_with_joint_sealing_paving_with_joint_sealing',
            t5AboveGroundTrack:
              'expert.subystem_and_areas.table.above_ground_track_system_solid_road',
            t5Ramps:
              'expert.subystem_and_areas.table.ramps_with_an_incline_towards_the_building_regardless_of_the_incline_and_type_of_fastening',
            t5SyntheticSports:
              'expert.subystem_and_areas.table.synthetic_surfaces_of_sports_fields',
            t5PartiallyPermeable:
              'expert.subystem_and_areas.table.partially_permeable_and_weakly_conductive_surfaces',
            t5ConcretePavingSandSlag:
              'expert.subystem_and_areas.concrete_paving_stones_laid_in_sand_or_shingle_surfaces_with_slabs',
            t5PavedJointRatio:
              'expert.subystem_and_areas.table.paved_areas_with_joints_greater_than_15_percent_10cm_x_10cm_and_small_or_solid_gravel_surface',
            t5WaterBound: 'expert.subystem_and_areas.table.water_bound_areas',
            t5LooseGravel:
              'expert.subystem_and_areas.table.loose_gravel_surface_gravel_lawn_children_playgrounds',
            t5CompositeStones:
              'expert.subystem_and_areas.table.composite_stones_with_drainage_joints_drainage_stones',
            t5GrassPaversFrequent:
              'expert.subystem_and_areas.table.grass_pavers_with_frequent_traffic_loads_parking_lot',
            t5GrassPaversNoFrequent:
              'expert.subystem_and_areas.table.lawn_gravel_stones_without_frequent_traffic_loads_fire_traffic_jams',
            t5TrackPermeable:
              'expert.subystem_and_areas.table.track_system_ballast_construction_with_permeable_substructure',
            t5TrackWeakPermeable:
              'expert.subystem_and_areas.table.track_system_ballast_construction_with_weakly_permeable_substructure',
            t5SportsDrainage: 'expert.subystem_and_areas.table.sports_areas_with_drainage',
            t5SyntheticTurf: 'expert.subystem_and_areas.table.synthetic_surfaces_synthetic_turf',
            t5ClayCourts: 'expert.subystem_and_areas.table.clay_courts_hard_ash_slag_heap',
            t5Lawns: 'expert.subystem_and_areas.table.lawns',
            t5PermeableSurfaces: 'expert.subystem_and_areas.table.permeable_surfaces',
            t5ParksLawnsGardens: 'expert.subystem_and_areas.table.parks_lawns_gardens',
            t5FlatTerrain: 'expert.subystem_and_areas.table.flat_terrain',
            t5SteepTerrain: 'expert.subystem_and_areas.table.steep_terrain',
            t5PermanentlyDammed: 'expert.subystem_and_areas.table.permanently_dammed_water_streams',
            t5FootnoteTitle: 'expert.subystem_and_areas.table.footnote.title',
            t5FootnoteA: 'expert.subystem_and_areas.table.footnote.a',
            t5FootnoteB: 'expert.subystem_and_areas.table.footnote.b',
            t5FootnoteC: 'expert.subystem_and_areas.table.footnote.c',
            poNo: 'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.nr',
            poTypeOfLand:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.type_of_land',
            poCoefficientsNote:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.coefficients_relate_exclusively_to_surfaces',
            poPeakDischargeCoefficient:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.peak_discharge_coefficient',
            poCs: 'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.c_s',
            poNr1: 'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.nr_1',
            poWaterImpermeable:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.water_impermeable_surfaces',
            poRoofSurfaces:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.roof_surfaces',
            poPitchedRoof:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.pitched_roof',
            poMetalGlassSlateFibre:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.metal_glass_slate_fibre_cement',
            poBricksWaterproofing:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.bricks_waterproofing_membranes',
            poFlatRoof:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.flat_roof_3_5',
            poMetalGlassFibre:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.metal_glass_fibre_cement',
            poWaterproofingMembranes:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.waterproofing_membranes',
            poGravelFill:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.gravel_fill',
            poGreenRoofs:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.green_roofs',
            poExtensiveGreening:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.extensive_greening',
            poIntensiveGreening30:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.intensive_greening_30',
            poExtensiveGreening10:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.extensive_greening_10',
            poExtensiveGreeningBellow10:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.extensive_greening_bellow_10',
            poTrafficAreas:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.traffic_areas',
            poConcreteSurfaces:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.concrete_surfaces',
            poBlacktop:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.blacktop',
            poJointGrouting:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.joint_grouting',
            poRamps: 'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.ramps',
            poInclinationToBuilding:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.inclination_to_the_building',
            poNr2: 'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.nr_2',
            poPartiallyPermeable:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.partially_permeable',
            poAreasWithSlabs:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.areas_with_slabs',
            poPavedJointProportion:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.paved_surfaces_with_joint_proportion',
            poWaterBoundAreas:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.water_bound_areas',
            poLooseGravelSurface:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.loose_gravel_surface',
            poInterlockingBlocks:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.interlocking_blocks',
            poGrassPaversCarPark:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.grass_pavers_car_park',
            poGrassPaversFireBrigade:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.grass_pavers_fire_brigade',
            poSportsWithDrainage:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.sports_surfaces_with_drainage',
            poSyntheticSurfaces:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.synthetic_surfaces',
            poThreshingFloors:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.threshing_floors',
            poLawns: 'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.lawns',
            poNr3: 'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.nr_3',
            poParksLawnsGardens:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.parks_lawns_gardens',
            poFlatTerrain:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.flat_terrain',
            poSteepTerrain:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.steep_terrain',
            poFootnote:
              'expert.subystem_and_areas.proof_of_overflow_runoffcoefficient_table.footnote',
          },
        },
        infiltrationSystemType: {
          heading: 'expert.dimensioning.please_choose_dimensioning_type_infiltration',
          dimensioningType:
            'expert.dimensioning_workflow_option.storm_water_infiltration_(DWA-M_138)_with_optional_treatment',
          invalidTypeChosen: 'expert.invalid_type_chosen',
          quickAndEasySwitchToExpert:
            'expert.dimensioning_workflow.quick_and_easy_switch_to_expert',
          drainInfiltration: 'expert.dimensioning_workflow_option.drain_infiltration',
          infiltrationViaDrainAndTrench:
            'expert.dimensioning_workflow_option.infiltration_via_drain_and_trench',
          trenchInfiltration: 'expert.dimensioning_workflow_option.trench_infiltration',
          withRigofillBlocks:
            'expert.dimensioning_workflow_option.infiltration_with_rigofill_blocks',
          withSwalePipes: 'expert.dimensioning_workflow_option.infiltration_with_swale_pipes',
          rigofillInspect: 'expert.dimensioning_workflow_option.rigofil_inspect',
          rigofillInspectNew: 'expert.dimensioning_workflow_option.rigofil_inspect_new',
          rigofillSt: 'Rigofill ST',
          rigofillStb: 'Rigofill ST-B',
          rigofillSts: 'Rigofill ST-S',
          rigofillSta: 'Rigofill ST-A',
          rigofillStv: 'Rigofill ST-V',
          rigofillStvhl: 'Rigofill ST-VHL',
          sickuPipe: 'expert.dimensioning_workflow_option.pipe_swale_sicku_pipe',
          muriPipe: 'expert.dimensioning_workflow_option.pipe_swale_muri_pipe',
          selectedText: {
            rigofillInspect: 'expert.dimensioning_workflow_option.rigofil_inspect_new_data',
            rigofillSta: 'expert.dimensioning_workflow_option.rigofil_inspect_sta_data',
            rigofillSts: 'expert.dimensioning_workflow_option.rigofil_inspect_sts_data',
          },
          popup: {
            rigofillInspect: 'info_pop_up_3_1',
            rigofillSt: 'info_pop_up_3_2',
            rigofillStb: 'info_pop_up_3_3',
            sickuPipe: 'info_pop_up_3_4',
            swalePipesDrain: 'info_pop_up_3_10',
            rigofillBlocksDrain: 'info_pop_up_3_11',
            muriPipe: 'info_pop_up_3_12',
            swalePipesDrainAndTrench: 'info_pop_up_3_14',
            rigofillBlocksDrainAndTrench: 'info_pop_up_3_15',
            rigofillInspectNew: 'info_pop_up_3_18',
            rigofillSta: 'info_pop_up_3_19',
            rigofillSts: 'info_pop_up_3_20',
          },
        },
        detentionWorkflowOption: {
          heading: 'expert.dimensioning.please_choose_dimensioning_type_detention',
          dimensioningType:
            'expert.dimensioning_workflow_option.storm_water_detention_dwa_a_117_with_optional_treatment',
          dimensioningTypeCzech:
            'expert.dimensioning_workflow_option.storm_water_detention_tnv_75_9011',
          invalidTypeChosen: 'expert.invalid_type_chosen',
          rigofillInspect: 'expert.dimensioning_workflow_option.rigofil_inspect',
          rigofillInspectNew: 'expert.dimensioning_workflow_option.rigofil_inspect_new',
          rigofillSt: 'Rigofill ST',
          rigofillStb: 'Rigofill ST-B',
          rigofillSts: 'Rigofill ST-S',
          rigofillSta: 'Rigofill ST-A',
          selectedText: {
            rigofillInspect: 'expert.dimensioning_workflow_option.rigofil_inspect_new_data',
            rigofillSta: 'expert.dimensioning_workflow_option.rigofil_inspect_sta_data',
            rigofillSts: 'expert.dimensioning_workflow_option.rigofil_inspect_sts_data',
          },
          popup: {
            rigofillInspect: 'info_pop_up_3_1',
            rigofillSt: 'info_pop_up_3_2',
            rigofillStb: 'info_pop_up_3_3',
            rigofillInspectNew: 'info_pop_up_3_18',
            rigofillSta: 'info_pop_up_3_19',
            rigofillSts: 'info_pop_up_3_20',
          },
        },
        detentionSystemType: {
          heading: 'expert.detention.please_choose_a_system_type',
          invalidTypeChosen: 'expert.invalid_type_chosen',
          openOnTopTubModel: 'expert.detention.storm_water_detention_basin_open_on_top_tub_model',
          tankModelAddCone:
            'expert.detention.storm_water_detention_basin_tank_model_sealed_up_to_upper_edge_of_terrain_add_cone',
          tankModel:
            'expert.detention.storm_water_detention_basin_tank_model_sealed_up_to_upper_edge_of_terrain',
          popup: {
            openOnTopTubModel: 'info_pop_up_3_16',
            tankModel: 'info_pop_up_3_17',
          },
        },
        treatmentWorkflowOption: {
          heading: 'expert.dimensioning.please_choose_dimensioning_type_treatment',
          dimensioningType:
            'expert.dimensioning_workflow.storm_water_treatment_without_storage_volume',
          dimensioningTypeWithStorageVolume:
            'expert.dimensioning_workflow.storm_water_treatment_with_storage_volume',
          invalidTypeChosen: 'expert.invalid_type_chosen',
          option: {
            dwaA138: 'treatment_according_to_DWA_A_138_dimensioning_step',
            dwaM153: 'treatment_according_to_DWA_M_153_dimensioning_step',
            dwaM153WithoutVolumeDetermination:
              'storm_water_treatment_without_storage_volume_DWA_M_153',
            lfubw: 'treatment_according_to_LUBW_dimensioning_step',
            nrw: 'treatment_according_to_NRW_dimensioning_step',
            dwaA102: 'expert_dimensioning_workflow_DWA_A_102',
            rews: 'treatment_according_to_workflow_REWS',
          },
          tooltip: {
            dwaA138: 'expert.dimensioning_workflow.dwa_a_138_tooltip',
            dwaM153: 'expert.dimensioning_workflow.dwam153_tooltip',
            lfubw: 'expert.dimensioning_workflow.lubw_tooltip',
            nrw: 'expert.dimensioning_workflow.nrw_tooltip',
            dwaA102GermanyAustria: 'expert.dimensioning_workflow.dwaa102_de_at_tooltip',
            dwaA102OtherCountries: 'expert.dimensioning_workflow.dwaa102_other_countries_tooltip',
            rews: 'expert.dimensioning_workflow.rews_tooltip',
          },
        },
        areaForTreatmentSelection: {
          heading: 'expert.area_for_treatment_selection.area_allocation',
          a102Question: 'expert.area_for_treatment_selection.a102_please_select_which_subareas',
          rewsQuestion: 'expert.area_for_treatment_selection.rews_please_select_which_subareas',
          areaName: 'expert.area_for_treatment_selection.area_name',
          areaSize: 'expert.area_for_treatment_selection.area_size',
          considerArea: 'expert.area_for_treatment_selection.consider_area',
        },
        areaAssignment: {
          heading: 'expert.area_assignment.area_classification',
          questionDwaA138:
            'expert.area_assignment.do_you_want_to_allocate_the_partial_areas_of_the_discharge_point_to_different_treatment_plants',
          questionDwaA138Tooltip:
            'expert.area_assignment.do_you_want_to_allocate_the_partial_areas_of_the_discharge_point_to_different_treatment_plants.tooltip',
          questionDwaA102:
            'expert.area_assignment.do_you_want_to_allocate_the_partial_areas_of_the_discharge_point_to_different_treatment_plants_or_discharge_partial_areas_without_treatment_into_the_water_body',
          questionDwaM153:
            'expert.area_assignment.do_you_want_to_assign_the_areas_to_different_treatment_systems_or_leave_some_of_them_without_treatment',
          yes: 'expert.area_assignment.yes',
          no: 'expert.area_assignment.no',
          system: 'expert.area_assignment.dropdown_treatment',
          subarea: 'expert.area_assignment.dwa_a_138_subarea',
          treatmentVia: 'expert.area_assignment.dwa_a_138_treatment_via',
          areaGroup: 'expert.area_assignment.dwa_a_138_area_group',
          loadCategory: 'expert.area_assignment.dwa_a_138_load_category',
          categoryNote: 'expert.area_assignment.area_category_note',
          specialSurfaceGroupNote:
            'expert.selection_of_treatment.popup.treatment_has_special_surface_group_note',
          noTreatment: 'expert.area_assignment.no_treatment',
          area: 'expert.area_assignment.area',
          treatmentViaDwaM153: 'expert.area_assignment.table_header_treatment',
          pollutionLoadType: 'expert.area_assignment.load_type',
          nrwArea: 'expert.area_assignment.nrw_area',
          nrwTreatmentVia: 'expert.area_assignment.nrw_table_header_treatment',
          nrwCategory: 'expert.area_assignment.nrw_table_header_category',
          nrwCentralWaterTreatment: 'expert.area_assignment.central_water_treatment',
          nrwCategoryValues: {
            first: 'expert.area_assignment.nrw_table_category_I_value',
            second: 'expert.area_assignment.nrw_table_category_II_value',
            third: 'expert.area_assignment.nrw_table_category_III_value',
          },
          nrwPollutionTableCategories: {
            first: 'expert.area_assignment.nrw_pollution-table-category_I',
            second: 'expert.area_assignment.nrw_pollution-table-category_II',
            third: 'expert.area_assignment.nrw_pollution-table-category_III',
          },
          nrwPollutionDescription: 'expert.area_assignment.pollution-table-nrw-description',
          /* Note above the table when an area of the categories III was chosen. */
          nrwCategoryThreeNote: 'expert.area_assignment.invalid_nrw_has_category_3_selected',
          /* Note above the table when an area without a treatment is not of category I. */
          nrwInvalidCategoryNote: 'expert.area_assignment.invalid_nrw_category_selected',
          descriptionHeader: 'expert.area_assignment.description',
          pollutionTableOneHeading:
            'expert.area_assignment.153_lubw_nrw_pollution_table_one_heading',
          pollutionTableTwoHeading:
            'expert.area_assignment.153_lubw_nrw_pollution_table_two_heading',
          pollutionTableTwoFooter: 'expert.area_assignment.153_nrw_pollution_table_two_footer',
          /* Notes below the tables A.2 and A.3 of the LUBW workflow. */
          pollutionTableAdditionTitle:
            'expert.water_type.lubw_area_assignment_tables_notes_addition_title',
          pollutionTableAdditionListTitle:
            'expert.water_type.lubw_area_assignment_tables_notes_addition_ul_title',
          pollutionTableAdditionItems: {
            /* The backend uses the legacy `ubw_` prefix for the second and third item. */
            first: 'expert.water_type.lubw_area_assignment_tables_notes_addition_ul_li_1',
            second: 'expert.water_type.ubw_area_assignment_tables_notes_addition_ul_li_2',
            third: 'expert.water_type.ubw_area_assignment_tables_notes_addition_ul_li_3',
          },
          pollution: 'expert.area_assignment.pollution',
          loadsFromTheAir: 'expert.area_assignment.loads_from_the_air',
          loadFromTheArea: 'expert.area_assignment.load_from_the_area',
          pollutionType: 'expert.area_assignment.type',
          pollutionPoints: 'expert.area_assignment.points',
          pollutionIntensity: 'expert.area_assignment.pollution-table.intensity',
          pollutionName: 'expert.area_assignment.pollution-table.pollution',
          totalArea: 'expert.area_assignment.total_area',
          /* Paved connected area A_b,a of the A 102 / REwS workflow. */
          totalArea102Rews: 'expert.area_assignment.total_area_102_rews',
          /* Category table of the REwS workflow. */
          rewsPollutionTable: {
            category: 'expert.area_assignment.rews_pollution_table.category',
            afs63: 'expert.area_assignment.rews_pollution_table.AFS63',
            categoryOne: 'expert.area_assignment.rews_pollution_table.category_one',
            categoryOneValue: 'expert.area_assignment.rews_pollution_table.category_one_value',
            categoryTwo: 'expert.area_assignment.rews_pollution_table.category_two',
            categoryTwoValue: 'expert.area_assignment.rews_pollution_table.category_two_value',
            categoryThree: 'expert.area_assignment.rews_pollution_table.category_three',
            categoryThreeValue: 'expert.area_assignment.rews_pollution_table.category_three_value',
            footer: 'expert.area_assignment.rews_pollution_table.footer',
          },
          impenetrableArea: 'expert.area_assignment.impenetrable_area',
          treatmentAfter: 'expert.area_assignment.treatment_after',
          notConfigured: 'expert.area_assignment.not_configured',
          configure: 'expert.area_assignment.configure',
          table: {
            heading:
              'expert.area_assignment.102_pollution_table.allocation_of_load_categories_for_precipitation_water',
            subtitle: 'expert.area_assignment.102_pollution_table.table_a_1_categorization',
            areaType: 'expert.area_assignment.102_pollution_table.area_type',
            areaSpecification: 'expert.area_assignment.102_pollution_table.area_specification',
            areaGroupAbbreviations:
              'expert.area_assignment.102_pollution_table.area_group_abbreviations',
            loadCategory: 'expert.area_assignment.102_pollution_table.load_category',
            footer: 'expert.area_assignment.102_pollution_table.footer',
          },
          group: {
            roofs: 'expert.area_assignment.pollution-table-102-group.d',
            courtyardsAndTraffic: 'expert.area_assignment.pollution-table-102-group.vw_v',
            factoryAndSpecial: 'expert.area_assignment.pollution-table-102-group.bs',
          },
          // Dynamic key: the pollution type abbreviation is appended, e.g. `....vw1`
          description: 'expert.area_assignment.pollution-table-102-description',
        },
        treatmentName: {
          treatment1: 'expert.treatment_translation.treatment1',
          treatment2: 'expert.treatment_translation.treatment2',
          treatment3: 'expert.treatment_translation.treatment3',
          treatment4: 'expert.treatment_translation.treatment4',
          treatment5: 'expert.treatment_translation.treatment5',
          centralWaterTreatment: 'expert.treatment_translation.central_water_treatment',
          noTreatment: 'expert.treatment_translation.no_treatment',
        },
        treatmentOverview: {
          configuring: 'expert.treatment_overview.treatment_overview.configuring',
        },
        advancedOptions: {
          heading: 'expert.treatment_overview.advanced_options.advance_options',
          question:
            'expert.treatment_overview.advanced_options.do_you_want_to_add_advanced_options',
          yes: 'expert.treatment_overview.advanced_options.yes',
          no: 'expert.treatment_overview.advanced_options.no',
        },
        transistValue: {
          heading: 'expert.treatment_overview.transist_value.advance_options_transist_values',
          calculateSystemRequirementsFor:
            'expert.treatment_overview.transist_value.calculate_system_requirements_for',
          numberOfSystems: 'expert.treatment_overview.transist_value.number_of_systems',
          calculateSystemRequirements:
            'expert.treatment_overview.transist_value.calculate_system_requirements',
          requiredTransistValue: 'expert.transist_value.required_transist_value',
          maximumTreatableAreaWarning: 'expert.transist_value.maximum_treatable_area_warning',
        },
        rcritAssignment: {
          heading: 'expert.treatment_overview.rcrit_assignment.assign_rkrit_to_each_area',
          tooltip: 'expert.treatment_overview.rcrit_assignment.categories_explanation_tooltip',
          categoryOne: 'expert.treatment_overview.rcrit_assignment.category_I_value',
          categoryTwo: 'expert.treatment_overview.rcrit_assignment.category_II_value',
          categoryThree: 'expert.treatment_overview.rcrit_assignment.category_III_value',
        },
        basicOption: {
          heading: 'expert.treatment_overview.basic_option.treatment_via_d1_d2',
          variantSelectionTitle:
            'expert.treatment_overview.basic_option.please_choose_a_dimensioning_variant',
          specifyInfiltrationArea:
            'expert.treatment_overview.basic_option.specify_the_possible_infiltration_area_as',
          calculateInfiltrationArea:
            'expert.treatment_overview.basic_option.calculate_the_necessary_infiltration_area_as',
          takeoverSeepageArea:
            'expert.treatment_overview.basic_option.takeover_of_the_seepage_area_as_from_volume_design',
          infiltrationArea: 'expert.treatment_overview.basic_option.infiltration_area',
          inspectArea: 'expert.treatment_overview.basic_option.inspect_area',
          /* DWA-M 153 / LUBW wording of the dimensioning variants (legacy `!== DWAA138`). */
          defineInfiltrationArea:
            'expert.treatment_overview.basic_option.define_infiltration_area_transist_value_will_be_calculated',
          calculateRequiredInfiltrationArea:
            'expert.treatment_overview.basic_option.calculate_the_required_infiltration_area_from_the_required_transist_value',
          calculateTransistValue: 'expert.treatment_overview.basic_option.calculate_transist_value',
          requiredInfiltrationArea:
            'expert.treatment_overview.basic_option.required_infiltration_area',
          assignedArea: 'expert.treatment_overview.basic_option.assigned_area',
          areaPollution: 'expert.treatment_overview.basic_option.area_polution',
          waterTypePoints: 'expert.treatment_overview.basic_option.water_type_points',
          dischargePollution: 'expert.treatment_overview.basic_option.discharge_pollution',
          transistValueOfGroundPassage:
            'expert.treatment_overview.basic_option.transist_value_of_ground_passage',
          emissionValue: 'expert.treatment_overview.basic_option.emission_value',
          permissibleTransistValue:
            'expert.treatment_overview.basic_option.maximum_permissible_transist_value',
          requiredSeepageArea: 'expert.treatment_overview.basic_option.required_seepage_area',
          existingSeepageArea: 'expert.treatment_overview.basic_option.existing_seepage_area',
          connectedArea: 'expert.treatment_overview.basic_option.connected_area_ac',
          areaGroup: 'expert.treatment_overview.basic_option.area_group_relevant_to_design',
          loadCategory:
            'expert.treatment_overview.basic_option.load_category_relevant_to_the_assessment',
          requiredAreaRatio: 'expert.treatment_overview.basic_option.required_area_ratio_ac_as_m',
          maxConnectableArea: 'expert.treatment_overview.basic_option.max_connectable_area',
          calculatedAreaRatio:
            'expert.treatment_overview.basic_option.calculated_area_ratio_ac_as_m',
          minRequiredSeepageArea:
            'expert.treatment_overview.basic_option.min_required_seepage_area_min',
          warningLessThanZero: 'expert.treatment_overview.basic_option.warning_less_then_zero',
          warningMoreThanZero: 'expert.treatment_overview.basic_option.warning_more_then_zero',
        },
        treatmentResults: {
          resultsFollowingDwaM153:
            'expert.treatment_overview.treatment_results.results_following_regulation_dwa_m_153',
          resultsFollowingLubw:
            'expert.treatment_overview.treatment_results.results_following_regulation_lubw',
          resultsAccordingToTheAssessment:
            'expert.treatment_overview.treatment_results.results_according_to_the_assessment',
          resultsFollowingNrw:
            'expert.treatment_overview.treatment_results.results_following_regulation_nrw',
          resultsFollowingDwaA102:
            'expert.treatment_overview.treatment_results.results_following_regulation_dwaa102',
          resultsFollowingRews:
            'expert.treatment_overview.treatment_results.results_following_regulation_rews',
          /** Keys of the REwS verification. */
          rews: {
            rainwaterTreatmentIsRequired:
              'expert.treatment_overview.treatment_results.rews.rainwater_treatment_is_required_please_provide_a_treatment_plant',
          },
          resultsFollowingDwaA138:
            'expert.treatment_overview.treatment_results.results_following_regulation_dwaa138',
          maximumTreatableAreaWarning:
            'expert.transist_value-result_output.maximum_treatable_area_warning',
          /** Results of the Trennerlass NRW (area table and data block). */
          nrw: {
            areaName: 'expert.treatment_overview.treatment_results.nrw.table_area_name',
            partialArea: 'expert.treatment_overview.treatment_results.nrw.table_partial_area',
            runOffCoefficient:
              'expert.treatment_overview.treatment_results.nrw.table_run_off_coefficient',
            impenetrableArea:
              'expert.treatment_overview.treatment_results.nrw.table_impenetrable_area',
            fractionOfTotalArea:
              'expert.treatment_overview.treatment_results.nrw.table_fraction_of_total_area',
            criticalRainAmount:
              'expert.treatment_overview.treatment_results.nrw.table_critical_rain_amount',
            category: 'expert.treatment_overview.treatment_results.nrw.table_category',
            origin: 'expert.treatment_overview.treatment_results.nrw.table_origin',
            surfaceLoading: 'expert.treatment_overview.treatment_results.nrw.surface_loading',
            surfaceLoadingResult:
              'expert.treatment_overview.treatment_results.nrw.surface_loading_result',
            criticalRainDonation:
              'expert.treatment_overview.treatment_results.nrw.critical_rain_donation',
            mediumCriticalRainDonation:
              'expert.treatment_overview.treatment_results.nrw.medium_critical_rain_donation',
            criticalRainwaterRunoff:
              'expert.treatment_overview.treatment_results.nrw.critical_rainwater_runoff',
            choiceOfRainwaterTreatment:
              'expert.treatment_overview.treatment_results.nrw.choice_of_rainwater_treatment',
            selectedTreatmentSystem:
              'expert.treatment_overview.treatment_results.nrw.selected_treatment_system',
            totalAreaConnected:
              'expert.treatment_overview.treatment_results.nrw.total_area_connected_to_the_selected_treatment',
            maximumConnectableArea:
              'expert.treatment_overview.treatment_results.nrw.maximum_connectable_area_for_selected_treatment',
            categoryThreeWarning:
              'expert.treatment_overview.treatment_results.nrw.category_III_warning',
            noStormwaterTreatment:
              'expert.treatment_overview.treatment_results.nrw.no_stormwater_treatment',
            centralWaterTreatment:
              'expert.treatment_overview.treatment_results.nrw.central_water_treatment',
            systemSelectionPiece:
              'expert.treatment_overview.treatment_results.nrw.system_selection_piece',
            systemSelectionPieces:
              'expert.treatment_overview.treatment_results.nrw.system_selection_pieces',
            productPrefix: 'expert.treatment_product',
            /* Legacy keys of the category and of the area example of a row. */
            categoryPrefix: 'expert.area_assignment.pollution-table-nrw',
            /* The rows of the table show the short description of the area example. */
            originPrefix: 'expert.area_assignment.pollution-table-nrw-short-description',
          },

          /** Sections of the DWA-A 102 / REwS verification (item 5.2.3.2). */
          dwaa102: {
            designValues: 'expert.treatment_overview.treatment_results.dwaa102.design_values',
            connectedPavedArea:
              'expert.treatment_overview.treatment_results.dwaa102.connected_paved_area',
            annualMaterialRemoval:
              'expert.treatment_overview.treatment_results.dwaa102.annual_material_removal',
            areaSpecificSubstanceRemoval:
              'expert.treatment_overview.treatment_results.dwaa102.area_specific_substance_removal',
            requiredEfficiency:
              'expert.treatment_overview.treatment_results.dwaa102.required_efficiency',
            requiredEfficiencyIsUserInput:
              'expert.treatment_overview.treatment_results.dwaa102.required_efficiency_is_user_input',
            desiredEfficiencyNwt:
              'expert.treatment_overview.treatment_results.dwaa102.desired_efficiency_NWT',
            desiredEfficiencyNwtSuffix:
              'expert.treatment_overview.treatment_results.dwaa102.desired_efficiency_NWT_suffix',
            rainwaterTreatmentIsRequired:
              'expert.treatment_overview.treatment_results.dwaa102.rainwater_treatment_is_required_please_provide_a_treatment_plant',
            resultOfTheDesign:
              'expert.treatment_overview.treatment_results.dwaa102.result_of_the_design_according_to_DWA-A_102-2',
            areaSpecificAnnualSubstanceDischarge:
              'expert.treatment_overview.treatment_results.dwaa102.area_specific_annual_substance_discharge',
            permissibleAreaSpecificAnnualSubstanceDischarge:
              'expert.treatment_overview.treatment_results.dwaa102.permissible_area_specific_annual_substance_discharge',
            verification: 'expert.treatment_overview.treatment_results.dwaa102.verification',
            verificationFullfiled:
              'expert.treatment_overview.treatment_results.dwaa102.verification_fullfiled',
            verificationFullfiledText:
              'expert.treatment_overview.treatment_results.dwaa102.verification_fullfiled_text',
            verificationNotFullfiled:
              'expert.treatment_overview.treatment_results.dwaa102.verification_not_fullfiled',
            verificationNotFullfiledText:
              'expert.treatment_overview.treatment_results.dwaa102.verification_not_fullfiled_text',
            /* Required treatment system(s) acc. to DWA-A 102-2/BWK-A 3-2, Item 6.1.3.4. */
            requiredTreatmentPlants:
              'expert.treatment_overview.treatment_results.dwaa102.required_treatment_plants',
            systemSelectionPiece:
              'expert.treatment_overview.treatment_results.dwaa102.system_selection_piece',
            systemSelectionPieces:
              'expert.treatment_overview.treatment_results.dwaa102.system_selection_pieces',
            poolOverflowAdded:
              'expert.treatment_overview.treatment_results.dwaa102.pool_overflow_added',
            enclosedPavedArea:
              'expert.treatment_overview.treatment_results.dwaa102.enclosed_paved_area',
            existingEfficiencyOfTheSelectedTreatmentPlants:
              'expert.treatment_overview.treatment_results.dwaa102.existing_efficiency_of_the_selected_treatment_plants',
          },
          poolOverflowNotAdded:
            'expert.treatment_overview.treatment_results.pool_overflow_not_added',

          /** Sections of the LUBW verification (same structure as the DWA-M 153 keys). */
          lubw: {
            areaPollutionWarning:
              'expert.treatment_overview.treatment_results.lubw.basic_option_area_polution_warning',
            permissibleTransistValueWarning:
              'expert.treatment_overview.treatment_results.lubw.maximum_permissible_transist_value_warning',
            dischargeWaters: 'expert.treatment_overview.treatment_results.lubw.discharge_waters',
            watersTables:
              'expert.treatment_overview.treatment_results.lubw.waters_tables_1a_and_1b',
            typeOfWaterBody: 'expert.treatment_overview.treatment_results.lubw.type_of_water_body',
            waterPoints: 'expert.treatment_overview.treatment_results.lubw.water_points',
            runoffLoad: 'expert.treatment_overview.treatment_results.lubw.runoff_load',
            load: 'expert.treatment_overview.treatment_results.lubw.load',
            rainwaterTreatment:
              'expert.treatment_overview.treatment_results.lubw.rainwater_treatment',
            treatmentRequired:
              'expert.treatment_overview.treatment_results.lubw.rainwater_treatment_required',
            treatmentNotRequired:
              'expert.treatment_overview.treatment_results.lubw.rainwater_treatment_not_required',
            determinedTransistValue:
              'expert.treatment_overview.treatment_results.lubw.determined_continuity_value',
            maximumPermissibleTransistValue:
              'expert.treatment_overview.treatment_results.lubw.maximum_permissible_transit_value',
            choiceOfTreatment:
              'expert.treatment_overview.treatment_results.lubw.choice_of_rainwater_treatment',
            choiceType:
              'expert.treatment_overview.treatment_results.lubw.choice_of_rainwater_treatment_typ',
            criticalRainfallDonation:
              'expert.treatment_overview.treatment_results.lubw.choice_of_rainwater_treatment_critical_rainfall_donation',
            intendedTreatmentMeasure:
              'expert.treatment_overview.treatment_results.lubw.intended_treatment_measure',
            existingInfiltrationArea:
              'expert.treatment_overview.treatment_results.lubw.existing_infiltration_area',
            requiredInfiltrationArea:
              'expert.treatment_overview.treatment_results.lubw.required_infiltration_area',
            connectedEffectiveArea:
              'expert.treatment_overview.treatment_results.lubw.connected_effective_drainage_area',
            areaPollution: 'expert.treatment_overview.treatment_results.lubw.area_polution',
            transistValueOfGroundPassage:
              'expert.treatment_overview.treatment_results.lubw.transist_value_of_ground_passage',
            systemSelection: 'expert.treatment_overview.treatment_results.lubw.system_selection',
            systemSelectionPiece:
              'expert.treatment_overview.treatment_results.lubw.system_selection_piece',
            systemSelectionPieces:
              'expert.treatment_overview.treatment_results.lubw.system_selection_pieces',
            transistValueOfTheSystems:
              'expert.treatment_overview.treatment_results.lubw.transit_value_of_the_systems',
            connectableAreaPerTreatment:
              'expert.treatment_overview.treatment_results.lubw.connectable_area_per_treatment',
            verification: 'expert.treatment_overview.treatment_results.lubw.verification',
            emissionValue:
              'expert.treatment_overview.treatment_results.lubw.verification_emission_value',
            verificationWaterPoints:
              'expert.treatment_overview.treatment_results.lubw.verification_water_points',
            verificationTarget:
              'expert.treatment_overview.treatment_results.lubw.verification_to_be_aimed',
            verificationExamine:
              'expert.treatment_overview.treatment_results.lubw.verification_examine_need_for_treatment_more',
            addTreatmentSystemWarning:
              'expert.treatment_overview.treatment_results.lubw.please_add_a_treatment_system_warning',
            noTreatmentRequiredWarning:
              'expert.treatment_overview.treatment_results.lubw.no_treatment_required_warning',
          },
          dwaM153: {
            areaPollutionWarning:
              'expert.treatment_overview.treatment_results.dwam153.basic_option_area_polution_warning',
            permissibleTransistValueWarning:
              'expert.treatment_overview.treatment_results.dwam153.maximum_permissible_transist_value_warning',
            dischargeWaters: 'expert.treatment_overview.treatment_results.dwam153.discharge_waters',
            watersTables:
              'expert.treatment_overview.treatment_results.dwam153.waters_tables_A__1a_and_A_1b',
            typeOfWaterBody:
              'expert.treatment_overview.treatment_results.dwam153.type_of_water_body',
            waterPoints: 'expert.treatment_overview.treatment_results.dwam153.water_points',
            runoffLoad: 'expert.treatment_overview.treatment_results.dwam153.runoff_load',
            load: 'expert.treatment_overview.treatment_results.dwam153.load',
            rainwaterTreatment:
              'expert.treatment_overview.treatment_results.dwam153.rainwater_treatment',
            treatmentRequired:
              'expert.treatment_overview.treatment_results.dwam153.rainwater_treatment_required',
            treatmentNotRequired:
              'expert.treatment_overview.treatment_results.dwam153.rainwater_treatment_not_required',
            determinedTransistValue:
              'expert.treatment_overview.treatment_results.dwam153.determined_continuity_value',
            maximumPermissibleTransistValue:
              'expert.treatment_overview.treatment_results.dwam153.maximum_permissible_transit_value',
            choiceOfTreatment:
              'expert.treatment_overview.treatment_results.dwam153.choice_of_rainwater_treatment',
            choiceType:
              'expert.treatment_overview.treatment_results.dwam153.choice_of_rainwater_treatment_typ',
            criticalRainfallDonation:
              'expert.treatment_overview.treatment_results.dwam153.choice_of_rainwater_treatment_critical_rainfall_donation',
            intendedTreatmentMeasure:
              'expert.treatment_overview.treatment_results.dwam153.intended_treatment_measure',
            existingInfiltrationArea:
              'expert.treatment_overview.treatment_results.dwam153.existing_infiltration_area',
            requiredInfiltrationArea:
              'expert.treatment_overview.treatment_results.dwam153.required_infiltration_area',
            connectedEffectiveArea:
              'expert.treatment_overview.treatment_results.dwam153.connected_effective_drainage_area',
            areaPollution: 'expert.treatment_overview.treatment_results.dwam153.area_polution',
            transistValueOfGroundPassage:
              'expert.treatment_overview.treatment_results.dwam153.transist_value_of_ground_passage',
            systemSelection: 'expert.treatment_overview.treatment_results.dwam153.system_selection',
            systemSelectionPiece:
              'expert.treatment_overview.treatment_results.dwam153.system_selection_piece',
            systemSelectionPieces:
              'expert.treatment_overview.treatment_results.dwam153.system_selection_pieces',
            transistValueOfTheSystems:
              'expert.treatment_overview.treatment_results.dwam153.transit_value_of_the_systems',
            connectableAreaPerTreatment:
              'expert.treatment_overview.treatment_results.dwam153.connectable_area_per_treatment',
            verification: 'expert.treatment_overview.treatment_results.dwam153.verification',
            emissionValue:
              'expert.treatment_overview.treatment_results.dwam153.verification_emission_value',
            verificationWaterPoints:
              'expert.treatment_overview.treatment_results.dwam153.verification_water_points',
            verificationTarget:
              'expert.treatment_overview.treatment_results.dwam153.verification_to_be_aimed',
            verificationExamine:
              'expert.treatment_overview.treatment_results.dwam153.verification_examine_need_for_treatment_more',
            addTreatmentSystemWarning:
              'expert.treatment_overview.treatment_results.dwam153.please_add_a_treatment_system_warning',
            noTreatmentRequiredWarning:
              'expert.treatment_overview.treatment_results.dwam153.no_treatment_required_warning',
          },
          notConfigured: 'expert.area_assignment.not_configured',
          designValues: 'expert.treatment_overview.treatment_results.dwaa138.design_values',
          connectedAreaAeA:
            'expert.treatment_overview.treatment_results.dwaa138.connected_area_ae_a',
          connectedAreaAc: 'expert.treatment_overview.treatment_results.dwaa138.connected_area_ac',
          areaGroup:
            'expert.treatment_overview.treatment_results.dwaa138.area_group_relevant_to_design',
          loadCategory:
            'expert.treatment_overview.treatment_results.dwaa138.load_category_relevant_to_the_design',
          maxAcAsm: 'expert.treatment_overview.treatment_results.dwaa138.max_ac_asm',
          noRequirement: 'expert.treatment_overview.treatment_results.dwaa138.no_requirement',
          requiredEfficiency:
            'expert.treatment_overview.treatment_results.dwaa138.required_efficiency_η_afs_erf',
          requiredEfficiencyManual:
            'expert.treatment_overview.treatment_results.dwaa138.required_efficiency_η_afs_erf_manually_entered_value',
          requiredEfficiencyDissolved:
            'expert.treatment_overview.treatment_results.dwaa138.required_efficiency_ηsolutes_erf',
          requiredEfficiencyDissolvedManual:
            'expert.treatment_overview.treatment_results.dwaa138.required_efficiency_ηsolutes_erf_manually_entered_value',
          requiredAreaRatio:
            'expert.treatment_overview.treatment_results.dwaa138.required_area_ratio_ac_as_m',
          requiredAreaRatioManual:
            'expert.treatment_overview.treatment_results.dwaa138.required_area_ratio_ac_as_m_manually_entered_value',
          hint1: 'expert.treatment_overview.treatment_results.dwaa138.hint_1',
          hint2: 'expert.treatment_overview.treatment_results.dwaa138.hint_2',
          hint3: 'expert.treatment_overview.treatment_results.dwaa138.hint_3',
          hint4: 'expert.treatment_overview.treatment_results.dwaa138.hint_4',
          designResult:
            'expert.treatment_overview.treatment_results.dwaa138.result_of_the_design_according_to_dwa_a_138_1',
          selectedTreatmentPlant:
            'expert.treatment_overview.treatment_results.dwaa138.selected_treatment_plant',
          piece: 'expert.treatment_overview.treatment_results.dwaa138.piece',
          pieces: 'expert.treatment_overview.treatment_results.dwaa138.pieces',
          connectableAreaPerSystem:
            'expert.treatment_overview.treatment_results.dwaa138.connectable_area_per_system',
          connectedAreaPerPlant:
            'expert.treatment_overview.treatment_results.dwaa138.connected_paved_area_per_treatment_plant_ab_a_sedi',
          efficiencyOfSystem:
            'expert.treatment_overview.treatment_results.dwaa138.efficiency_of_the_system_η_afs_system',
          efficiencyOfPlant:
            'expert.treatment_overview.treatment_results.dwaa138.efficiency_of_the_plant_ηsubstances_plant',
          proof: 'expert.treatment_overview.treatment_results.dwaa138.proof',
          proofEfficiency:
            'expert.treatment_overview.treatment_results.dwaa138.η_afs_erf_≤_η_afs_appendix',
          proofDissolvedSubstances:
            'expert.treatment_overview.treatment_results.dwaa138.ηdissolved_substances_erf_≤_ηsubstances_appendix',
          choiceOfTreatment:
            'expert.treatment_overview.treatment_results.dwaa138.choice_of_rainwater_treatment',
          overgrownSoilZone:
            'expert.treatment_overview.treatment_results.dwaa138.infiltration_over_overgrown_soil_zone_≥_20_cm_or_≥_30_cm',
          verification: 'expert.treatment_overview.treatment_results.dwaa138.verification',
          existingSeepageArea:
            'expert.treatment_overview.treatment_results.dwaa138.existing_seepage_area',
          calculatedAreaRatio:
            'expert.treatment_overview.treatment_results.dwaa138.calculated_area_ratio_ac_as_m',
          verificationFulfilled:
            'expert.treatment_overview.treatment_results.dwaa138.verification_fullfiled',
          categoryOne: 'expert.treatment_category_one',
          categoryTwo: 'expert.treatment_category_two',
          categoryThree: 'expert.treatment_category_three',
        },
        selectionOfTreatmentSystem: {
          heading: 'expert.selection_of_treatment_systems.selection_of_treatment_systems',
          /* System type selection of the Trennerlass NRW. */
          nrw: {
            categoryOne:
              'expert.treatment_overview.selection_of_treatment_system.nrw_low_pollution_category_I',
            categoryOneTooltip:
              'expert.treatment_overview.selection_of_treatment_system.nrw_low_pollution_category_I_tooltip',
            protectionOfRigole:
              'expert.treatment_overview.selection_of_treatment_system.protection_of_rigole',
            rigoClean: 'expert.treatment_overview.selection_of_treatment_system.nrw_rigo_clean',
            categoryTwoThree:
              'expert.treatment_overview.selection_of_treatment_system.nrw_low_high_pollution_category_II_III',
            categoryTwoThreeTooltip:
              'expert.treatment_overview.selection_of_treatment_system.nrw_low_high_pollution_category_II_III_tooltip',
            followingChap:
              'expert.treatment_overview.selection_of_treatment_system.nrw_following_chap',
            sediPipeSediPoint:
              'expert.treatment_overview.selection_of_treatment_system.nrw_sedi_pipe_sedi_point',
            categoryTwoThreeSurfaceLoading4:
              'expert.treatment_overview.selection_of_treatment_system.nrw_low_high_pollution_category_II_III_surface_loading_4',
            categoryTwoThreeTooltipSurfaceLoading4:
              'expert.treatment_overview.selection_of_treatment_system.nrw_low_high_pollution_category_II_III_tooltip_surface_loading_4',
            followingChapSurfaceLoading4:
              'expert.treatment_overview.selection_of_treatment_system.nrw_following_chap_surface_loading_4',
            sediPipeSediPointSurfaceLoading4:
              'expert.treatment_overview.selection_of_treatment_system.nrw_sedi_pipe_sedi_point_surface_loading_4',
            /* Tooltip of a system type that cannot treat the categories of the assigned areas. */
            disabledTooltip:
              'expert.treatment_overview.selection_of_treatment_system.disabled_system_tooltip',
            /* Details of the selected RigoClean system type. */
            rigoCleanDetails: 'expert.treatment_overview.nrw_category_I_pollution_description',
            /* Details of the selected SediPipe/SediPoint system type (surface loading 10). */
            sediPipeSediPointDetails:
              'expert.treatment_overview.nrw_not_category_I_pollution_description',
            /* Details of the selected SediPipe/SediPoint system type (surface loading 4). */
            sediPipeSediPointDetailsSurfaceLoading4:
              'expert.treatment_overview.nrw_not_category_I_pollution_description_surface_loading_4',
            disabledTooltipSurfaceLoading4:
              'expert.treatment_overview.selection_of_treatment_system.disabled_system_tooltip_surface_loading_4',
          },
          calculationBasis:
            'expert.selection_of_treatment_systems.material_evidence_calculated_on_basis_of',
          calculationBasisNature: 'expert.selection_of_treatment.a102_calculation_natur',
          calculationBasisMillisil: 'expert.selection_of_treatment.a102_calculation_millisil_w4',
          technicalPlantForRainwaterTreatment:
            'expert.selection_of_treatment.technical_plant_for_rainwater_treatment',
          technicalTreatmentPlant:
            'expert.selection_of_treatment.technical_treatment_plant_with_sufficient_efficiency_e_g_sedi_substrator_sedi_pipe_sedi_point',
          overgrownSoilZone: 'expert.selection_of_treatment.overgrown_soil_zone',
          infiltrationThrough30cm:
            'expert.selection_of_treatment.infiltration_through_30cm_overgrown_topsoil',
          infiltrationThrough20cm:
            'expert.selection_of_treatment.infiltration_through_20cm_overgrown_topsoil',
          specialSurfaceGroupsNote:
            'expert.selection_of_treatment.treatment_has_special_surface_group_note',
          dissolvedSubstances: {
            onlyCategoryDAreas: 'expert.selection_of_treatment.asf_table_equal_4',
            onlyDissolvedSubstancesAreas: 'expert.selection_of_treatment.asf_table_equal_5',
            question:
              'expert.selection_of_treatment.should_dissolved_substances_according_to_dwa_a_138_1_table_7_copper_and_zinc_be_taken_into_account',
          },
          passage: {
            onlyCategoryDAreas: 'expert.selection_of_treatment.floor_passage_table_equal_1',
            standalone: 'expert.selection_of_treatment.floor_passage_table_equal_2_standalone',
            ditchDesignWorkflow:
              'expert.selection_of_treatment.floor_passage_table_equal_2_ditch_design_workflow',
            onlyDissolvedSubstancesAreas:
              'expert.selection_of_treatment.floor_passage_table_equal_3',
          },
          requiredValues: {
            heading: 'expert.selection_of_treatment.please_enter_the_required_values',
            tableTitle: 'expert.selection_of_treatment.dwaa_138_title',
            table6Title: 'expert.selection_of_treatment.dwaa_138_title_table_6',
            footnoteTitle: 'expert.selection_of_treatment.dwaa_138_table_footnote.title',
            footnoteA: 'expert.selection_of_treatment.dwaa_138_table_footnote.a',
            footnoteB: 'expert.selection_of_treatment.dwaa_138_table_footnote.b',
            footnoteC: 'expert.selection_of_treatment.dwaa_138_table_footnote.c',
            etaAfs63: 'expert.selection_of_treatment.required_η_afs63',
            etaDissolvedSubstances: 'expert.selection_of_treatment.required_ηdissolved_substances',
            etaDissolvedSubstancesTooltip:
              'expert.selection_of_treatment.required_ηdissolved_substances.tooltip',
            acasm: 'expert.selection_of_treatment.required_acasm',
          },
          continueToResultPage: 'expert.selection_of_treatment_systems.continue_to_result_page',
          selectTreatmentPlant: 'expert.selection_of_treatment_systems.select_treatment_plant',
          hasOnlyCategoryOneAreas:
            'expert.selection_of_treatment_systems.has_only_category_one_areas',
          a102PoolOverflowQuestion:
            'expert.selection_of_treatment_systems.do_you_want_to_include_a_pool_overflow_before_the_treatment_plant_in_the_calculation',
          a102PoolOverflowTooltip: 'expert.selection_of_treatment.a102_pool_overflow_tooltip',
          a102CalculationBasisTooltip:
            'expert.selection_of_treatment.a102_calculation_basis_tooltip',
          a102DesiredEfficiencyTitle:
            'expert.selection_of_treatment_systems.please_specify_the_desired_efficiency_to_protect_the_plant_an',
          a102EnterEfficiencyTitle:
            'expert.selection_of_treatment_systems.please_enter_the_desired_efficiency_an',
          a102AdjustEfficiencyQuestion:
            'expert.selection_of_treatment_systems.do_you_want_to_adjust_the_calculated_efficiency',
          a102DesiredEfficiencyLabel: 'expert.selection_of_treatment.a102_efficiency_ηwt',
          a102DesiredEfficiencyTooltip:
            'expert.selection_of_treatment.a102_desired_efficiency_ηwt_tooltip',
          a102Subtitle: 'expert.treatment_overview.DWAA102_subtitle',
          rewsSubtitle: 'expert.treatment_overview.REWS_subtitle',
        },
        areaDrainOrTrench: {
          heading: 'expert.area_drain_or_trench.assignment_to_drain_or_trench',
          drain: 'expert.area_drain_or_trench.drain',
          trench: 'expert.area_drain_or_trench.trench',
          connectedSubareaRigole: 'expert.area_drain_or_trench.ae_a_rigole',
          connectedSubareaMulde: 'expert.area_drain_or_trench.ae_a_mulde',
          // DWA-A 138 (04/2005): the sums are the connected areas AEk of the storage/infiltration
          // system and of the swale (legacy `a_drain` / `a_trench`).
          aekStorageInfiltrationSystem: 'expert.area_drain_or_trench.a_drain',
          aekSwale: 'expert.area_drain_or_trench.a_trench',
          imageText: 'expert.area_drain_or_trench.image_text',
        },
        drainageCapability: {
          heading: 'expert.drainage_capability.drainage_capability_k',
          headingTrench: 'expert.drainage_capability.drainage_capability_for_trench_k',
          drainLabel: 'expert.drainage_capability.drainage_capability_for_drain_k',
          trenchLabel: 'expert.drainage_capability.drainage_capability_for_trench_k',
          selectFromPredefinedGroundTypes:
            'expert.drainage_capability.select_from_pre_defined_ground_types',
          freeInput: 'expert.drainage_capability.free_input',
          permeabilityWarning:
            'expert.drainage_capability.infiltration_one_and_two_drainage_capability_free_input_warning_message',
          soilTypes: {
            coarseGravel: 'expert.drainage_capability.coarse_gravel',
            fineMediumGravel: 'expert.drainage_capability.fine_medium_gravel',
            sandyGravel: 'expert.drainage_capability.sandy_gravel',
            coarseSand: 'expert.drainage_capability.coarse_sand',
            mediumSand: 'expert.drainage_capability.medium_sand',
            fineSand: 'expert.drainage_capability.fine_sand',
            siltySandSandySilt: 'expert.drainage_capability.silty_sand_sandy_silt',
            silt: 'expert.drainage_capability.silt',
            clayeySilt: 'expert.drainage_capability.clayey_silt',
            siltyClayClay: 'expert.drainage_capability.silty_clay_clay',
          },
          correctionFactorFOrt:
            'expert.drainage_capability.please_select_a_local_correction_factor_fort',
          correctionFactorFMethod:
            'expert.drainage_capability.please_select_a_correction_factor_f_method_to_take_into_account_the_determination_method_used',
          fMethod: {
            largeScaleFieldTrials:
              'expert.drainage_capability.f_method_option.large_scale_field_trials',
            largeScaleFieldTestsInTestPitTestExcavation:
              'expert.drainage_capability.f_method_option.large_scale_field_tests_in_test_pit_test_excavation',
            smallScaleFieldTrials:
              'expert.drainage_capability.f_method_option.small_scale_field_trials',
            smallTestPitTrialPit:
              'expert.drainage_capability.f_method_option.small_test_pit_trial_pit',
            doubleCylinderInfiltrometer:
              'expert.drainage_capability.f_method_option.double_cylinder_infiltrometer',
            openEndTest: 'expert.drainage_capability.f_method_option.open_end_test',
            laboratoryProcedures:
              'expert.drainage_capability.f_method_option.laboratory_procedures',
            laboratoryProceduresWithUndisturbedSamples:
              'expert.drainage_capability.f_method_option.laboratory_procedures_with_undisturbed_samples',
            laboratoryProcedureWithDisturbedSamples:
              'expert.drainage_capability.f_method_option.laboratory_procedure_with_disturbed_samples_sieving_curve_evaluation_for_sandy_soils',
          },
          infiltrationRateKi: 'expert.drainage_capability.design_relevant_infiltration_rate_ki',
          infiltrationRateKiTrench:
            'expert.drainage_capability.design_relevant_infiltration_rate_ki_trench',
          // DWA-A 138 (04/2005) infiltration flow: labels and correction factor types that only exist
          legacy: {
            heading: 'expert.drainage_capability.drainage_capability',
            headingCzech: 'expert.drainage_capability.drainage_capability_czech',
            trenchHeading: 'expert.drainage_capability.drainage_capability_for_trench',
            drainLabel: 'expert.drainage_capability.drainage_capability_for_drain',
            drainLabelCzech: 'expert.drainage_capability.drainage_capability_for_drain_czech',
            trenchLabel: 'expert.drainage_capability.drainage_capability_for_trench',
            pleaseChooseCorrectionFactor:
              'expert.drainage_capability.please_choose_the_correction_factor',
            correctionFactors: {
              estimateFromGroundType: 'expert.drainage_capability.estimate_from_ground_type',
              labMeasurement: 'expert.drainage_capability.lab_measurement',
              determinationViaGrainSizeCurves:
                'expert.drainage_capability.determination_via_grain_size_curves',
              determinationViaFieldTest: 'expert.drainage_capability.determination_via_field_test',
            },
            permeabilityWarningCzech:
              'expert.drainage_capability.less_then_1e_6_tooltip_warning_czech',
            imageText: 'expert.drainage_capability.image_text',
            imageTextCzech: 'expert.drainage_capability.image_text_czech',
          },
          imageText: 'expert.drainage_capability.image_text_k',
          quickAndEasy: {
            heading: 'expert.drainage_capability.drainage_capability_of_the_existing_soil',
            good: 'expert.drainage_capability.drainage_capability_of_the_existing_soil_option_good',
            goodTooltip:
              'expert.drainage_capability.drainage_capability_of_the_existing_soil_option_good_tooltip',
            medium:
              'expert.drainage_capability.drainage_capability_of_the_existing_soil_option_medium',
            mediumTooltip:
              'expert.drainage_capability.drainage_capability_of_the_existing_soil_option_medium_tooltip',
            poor: 'expert.drainage_capability.drainage_capability_of_the_existing_soil_option_poor',
            poorTooltip:
              'expert.drainage_capability.drainage_capability_of_the_existing_soil_option_poor_tooltip',
            switchToExpert: 'expert.drainage_capability.quick_and_easy_switch_to_expert',
          },
          popup: {
            header: 'expert.drainage_capability.popup.header',
            text: 'expert.drainage_capability.popup.text',
            examples: 'expert.drainage_capability.popup.table.examples_of_evaluation_criteria',
            to: 'expert.drainage_capability.popup.table.to',
            soilConditions: 'expert.drainage_capability.popup.table.information_on_soil_conditions',
            soilConditionsIncomplete:
              'expert.drainage_capability.popup.table.information_situation_very_incomplete',
            soilConditionsSufficient:
              'expert.drainage_capability.popup.table.well_founded_sufficient_information_studies_are_available',
            trials:
              'expert.drainage_capability.popup.table.number_of_trials_and_variability_of_soil_conditions',
            trialsMinimum:
              'expert.drainage_capability.popup.table.minimum_requirements_regarding_number_of_trials_met_no_information_on_variability_of_soil_conditions',
            trialsAdapted:
              'expert.drainage_capability.popup.table.number_of_experiments_is_adapted_to_the_variability_of_soil_conditions',
            construction:
              'expert.drainage_capability.popup.table.practical_construction_evaluation_of_determined_permeability_coefficients',
            constructionStrongInfluence:
              'expert.drainage_capability.popup.table.probably_strong_influence_on_permeability_due_to_construction_activity_excavation',
            constructionNoInfluence:
              'expert.drainage_capability.popup.table.no_expected_influence_on_permeability_due_to_construction_activity',
            expertise:
              'expert.drainage_capability.popup.table.expertise_in_determining_the_infiltration_rate_kf_value',
            expertisePrivate:
              'expert.drainage_capability.popup.table.private_individual_without_specialist_knowledge',
            expertiseSpecialist:
              'expert.drainage_capability.popup.table.specialist_office_for_soil_reports_geotechnics',
          },
        },
        trenchSystemSpecifications: {
          heading: 'expert.trench_system_specifications.trench_system_specifications',
          mandatoryData: 'expert.trench_system_specifications.mandatory_data',
          optionalSpecifications: 'expert.trench_system_specifications.optional_specifications',
          totalConnectedArea: 'expert.trench_system_specifications.total_connected_area_ae_a_m',
          totalConnectedAreaSingle:
            'expert.trench_system_specifications.total_connected_area_a_e_a',
          meanRunoffCoefficient: 'expert.trench_system_specifications.mean_runoff_coefficient_cm_m',
          meanRunoffCoefficientSingle:
            'expert.trench_system_specifications.mean_runoff_coefficient_cm',
          reducedArea: 'expert.trench_system_specifications.reduced_area_calculated_value_acm',
          reducedAreaSingle: 'expert.trench_system_specifications.reduced_area_calculated_value_ac',
          designFrequency: 'expert.trench_system_specifications.design_frequency_t',
          // DWA-A 138 (04/2005): the trench (swale) step names the same fields without the
          // DWA-A 138-1 (10/2024) suffixes.
          rainRecurringInterval: 'expert.trench_system_specifications.rain_recurring_interval',
          totalArea: 'expert.trench_system_specifications.total_area',
          averageRunOffCoefficient:
            'expert.trench_system_specifications.average_run_off_coefficient',
          impenetrableAreaAuMulde:
            'expert.trench_system_specifications.impenetrable_area_a_u_mulde',
          trenchLength: 'expert.trench_system_specifications.trench_length',
          trenchWidth: 'expert.trench_system_specifications.trench_width_(upper_edge)',
          selectedTrenchDepth: 'expert.trench_system_specifications.selected_trench_depth',
          additionalWaterIntoDrenchRigole:
            'expert.system_specifications.additional_water_into_drench_rigole',
          additionalFactor: 'expert.trench_system_specifications.additional_factor',
          additionalFactorTooltip:
            'expert.trench_system_specifications.input_values_between_1_and_1_2_are_allowed',
          length: 'expert.trench_system_specifications.trough_length_lm',
          width: 'expert.trench_system_specifications.trough_width_b_m',
          depth: 'expert.trench_system_specifications.selected_water_level_h_m_gew',
          depthTooltip:
            'expert.trench_system_specifications.trench_system_specification_first_tooltip__message',
          angleOfRepose: 'expert.trench_system_specifications.angle_of_repose',
          angleOfReposeTooltip:
            'expert.trench_system_specifications.trench_system_specification_second_tooltip__message',
          additionalWaterIntoDrench:
            'expert.system_specifications.additional_amount_of_water_into_the_trough',
          negativeTrenchWidth:
            'expert.trench_system_specification.trench_width_at_the_bottom_is_negative',
        },
        systemSpecifications: {
          heading: 'expert.system_specifications.system_specifications',
          drainSystemSpecifications: 'expert.system_specifications.drain_system_specifications',
          mandatoryData: 'expert.system_specifications.mandatory_data',
          results: 'expert.system_specifications.results',
          totalConnectedArea: 'expert.system_specifications.total_connected_area_ae_a',
          totalConnectedAreaRigole: 'expert.system_specifications.total_connected_area_ae_a_r',
          meanDischargeCoefficientCm: 'expert.system_specifications.mean_discharge_coefficient_cm',
          meanRunoffCoefficientRigole: 'expert.system_specifications.mean_runoff_coefficient_cm_r',
          reducedArea: 'expert.system_specifications.reduced_area_calculated_value_ac',
          reducedAreaRigole: 'expert.system_specifications.reduced_area_calculated_value_acr',
          // The detention flow of the shared step reports the areas of the Rigofill basin itself
          // (legacy `system-specifications.component.html` non-dimensioning-type-5 branch).
          totalAreaAek: 'expert.system_specifications.total_area_a_ek',
          averageRunOffCoefficient: 'expert.system_specifications.average_run_off_coefficient',
          averageRunOffCoefficientCzech:
            'expert.system_specifications.average_run_off_coefficient_czech',
          impenetrableArea: 'expert.system_specifications.impenetrable_area',
          impenetrableAreaCzech: 'expert.system_specifications.impenetrable_area_czech',
          designFrequency: 'expert.system_specifications.design_frequency_t',
          rainRecurringInterval: 'expert.system_specifications.rain_recurring_interval',
          storageCoefficientOfGravel: 'expert.system_specifications.storage_coefficient_of_gravel',
          designFrequencyPlaceholder:
            'expert.system_specifications.detention_rain_recurring_interval_default_value',
          additionalFactor: 'expert.system_specifications.additional_factor',
          additionalFactorTooltip:
            'expert.system_specifications.input_values_between_1_and_1_2_are_allowed',
          systemWidth: 'expert.system_specifications.system_width_b_r',
          systemHeight: 'expert.system_specifications.system_height_h_r',
          systemWidthW: 'expert.system_specifications.system_width',
          systemHeightH: 'expert.system_specifications.system_height',
          rows: 'expert.system_specifications.rows',
          layers: 'expert.system_specifications.layers',
          areTheSidesPermeable: 'expert.system_specifications.are_the_sides_permeable',
          optionalDataQuestion:
            'expert.system_specifications.infiltration_optional_specifications_question',
          optionalData: 'expert.system_specifications.optional_specifications',
          additionalWaterIntoDrench: 'expert.system_specifications.additional_water_into_drench',
          additionalWaterIntoDrainA117:
            'expert.system_specifications.additional_water_into_drain_a_117',
          controlShaftType: 'expert.system_specifications.control_shaft_type',
          pleaseChooseDischargeControlShaftType:
            'expert.system_specifications.please_choose_a_discharge_control_shaft_type',
          storageCoefficientOfFillingMaterial:
            'expert.system_specifications.storage_coefficient_of_the_filling_material_s_f',
          recommendedNumberOfPipeRuns:
            'expert.system_specifications.recommended_number_of_pipe_lines',
          selectedNumberOfPipeRuns: 'expert.system_specifications.selected_number_of_pipe_lines',
          maxNumberOfPipeRunsReached:
            'expert.system_specifications.maximum_number_of_pipe_lines_was_reached',
          pieces: 'expert.system_specifications.pcs',
          maximumAllowedFlow: 'expert.system_specifications.maximum_allowed_flow',
          throttleCharacteristics: 'expert.system_specifications.Throttle_characteristics',
          quickAndEasyMaxAllowedFlowTooltip:
            'expert.system_specifications.quick_and_easy_maximum_allowed_flow_tooltip',
          quickAndEasyAverageFlowTooltip:
            'expert.system_specifications.quick_and_easy_average_flow_tooltip',
          maxRetainableHeight: 'expert.system_specifications.max_retainable_height',
          hCorrespondsToSystemHeight: 'expert.system_specifications.h_corresponds_to_system_height',
          freeInput: 'expert.system_specifications.free_input',
          averageFlow: 'expert.system_specifications.average_flow',
          flowDuration: 'expert.system_specifications.flow_duration',
          reductionFactor: 'expert.system_specifications.reduction_factor',
          dischargeFlowQDrK: 'expert.system_specifications.discharge_flow_q_dr_k',
          dischargeFlowQDrU: 'expert.system_specifications.discharge_flow_q_dr_u',
          checkCap: 'expert.system_specifications.check_cap',
          pleaseSelectThrottleFirst: 'expert.system_specifications.please_select_throttle_first',
          aquaBackstop: 'expert.system_specifications.aqua_backstop',
          additionalOverflow: 'expert.system_specifications.additional_overflow',
          quadroOverflow: 'expert.system_specifications.quadro_overflow',
          inputOutsideSpecifications:
            'expert.system_specifications.input_is_outside_specifications_of_selected_dischagre_control_system',
          pleaseChooseDifferentProductOrAdjustInput:
            'expert.system_specifications.please_choose_different_product_or_adjust_input',
          throttleType: 'expert.system_specifications.internal_useer_throttle_type',
          outletDimension: 'expert.system_specifications.internal_user_outlet_dimensions',
          shaftTypeQuadroLimit: 'expert.system_specifications.shaft_type_quadro_limit',
          shaftTypeAquaLimit: 'expert.system_specifications.shaft_type_aqua_limit',
          shaftTypeAquaLimitTube: 'expert.system_specifications.shaft_type_aqua_limit_tube',
          shaftTypeRigoLimitV: 'expert.system_specifications.shaft_type_rigo_limit_v',
          shaftTypeByCustomer: 'expert.system_specifications.by_customer',
          permeableYes: 'expert.system_specifications.are_the_sides_permeable_yes',
          permeableNo: 'expert.system_specifications.are_the_sides_permeable_no',
          popup: {
            aquaBackstop: 'info_pop_up_4_5_1',
            quadroOverflow: 'info_pop_up_4_6_1',
            protectionCategory: 'expert.system_specifications.popup.table.protection_category',
            classificationArea: 'expert.system_specifications.popup.table.classification area',
            designFrequency:
              'expert.system_specifications.popup.table.design_frequency_1_time_in_t_or_inl',
            hazard:
              'expert.system_specifications.popup.table.for_people_environment_supply_economy_culture',
            exampleUse: 'expert.system_specifications.popup.table.example_use',
            propertyDrainageSmall:
              'expert.system_specifications.popup.table.property_drainage_with_ac_less_than_or_equal_to_800_m_squared',
            propertyDrainageLarge:
              'expert.system_specifications.popup.table.property_drainage_with_more_than_800_m_and_public_drainage',
            low: 'expert.system_specifications.popup.table.low',
            lowDescription:
              'expert.system_specifications.popup.table.areas_in_which_the_water_can_flow_off_or_remain_on_the_surface_without_causing_damage_and_without_restrictions_on_use',
            moderate: 'expert.system_specifications.popup.table.moderate',
            moderateDescription:
              'expert.system_specifications.popup.table.areas_in_which_flooding_can_cause_minor_to_moderate_damage_or_restrictions_on_use_and_which_do_not_endanger_safety_and_health',
            strong: 'expert.system_specifications.popup.table.strong',
            strongDescription:
              'expert.system_specifications.popup.table.areas_where_flooding_can_locally_cause_major_damage_or_restrictions_on_use_or_which_can_potentially_endanger_safety_and_health',
            veryStrong: 'expert.system_specifications.popup.table.very_strong',
            veryStrongDescription:
              'expert.system_specifications.popup.table.areas_in_which_flooding_can_lead_to_extensive_major_damage_or_restrictions_on_use_or_which_can_pose_an_acute_risk_to_safety_and_health',
            footnoteTitle: 'expert.system_specifications.popup.table.footnote.title',
            footnote: 'expert.system_specifications.popup.table.footnote.a',
          },
          warning: {
            frequencyOfExceedance: 'expert.system_specifications.warning.frequency_of_exceedance',
            infiltrationCapacity:
              'expert.system_specifications.warning.infiltration_discharge_capacity_qs',
          },
        },
        controlShafts: {
          heading: 'expert.control_shafts.control_shafts',
          quadroControl: 'expert.control_shafts.quadrocontrol',
          rigoControl: 'expert.control_shafts.rigocontrol',
          recommendedNumberOfShafts: 'expert.control_shafts.recommended_number_of_control_shafts',
          selectedNumberOfShafts: 'expert.control_shafts.selected_number_of_control_shafts',
          frontSideShafts: 'expert.control_shafts.thereof_frontal',
          trenchShafts: 'expert.control_shafts.thereof_trench_shafts',
          maxNumberOfShaftsTooltip:
            'expert.control_shafts.maximum_allowed_number_of_control_shafts_reached',
          maxNumberOfFrontalShaftsTooltip:
            'expert.control_shafts.maximum_allowed_number_of_frontal_shafts_reached',
          maxNumberOfTrenchShaftsTooltip:
            'expert.control_shafts.maximum_allowed_number_of_trench_shafts_reached',
          designDischargeForOverflow:
            'expert.control_shafts.design_discharge_for_the_overflow_qmu_erf',
          existingOverflowCapacity:
            'expert.control_shafts.existing_overflow_capacity_through_shafts_qmu_vorh',
          warning: 'expert.control_shafts.warning',
          notification: 'expert.system_specifications.number_of_shafts_notif',
        },
        dimensioningResults: {
          heading: 'expert.dimensioning_results.dimensioning_results',
          resultsMulde: 'expert.dimensioning_results.results_mulde',
          resultsInfiltration: 'expert.dimensioning_results.results_infiltration',
          requiredTrenchLength: 'expert.dimensioning_results.required_trench_length_l_r_erf',
          // DWA-A 138 (04/2005) results of the trench (swale) and of the storage/infiltration system
          trenchWidthAtTheBottom: 'expert.dimensioning_results.trench_width_at_the_bottom',
          requiredTrenchDepth: 'expert.dimensioning_results.required_trench_depth',
          requiredTrenchVolumeMulde: 'expert.dimensioning_results.required_trench_volume_mulde_erf',
          selectedTrenchVolumeMulde: 'expert.dimensioning_results.selected_trench_volume_mulde_gew',
          dimensionsInBlockGridLengthMulde:
            'expert.dimensioning_results.dimensions_in_block_grid_length_mulde',
          dimensionsInBlockGridWidthMulde:
            'expert.dimensioning_results.dimensions_in_block_grid_width_mulde',
          selectedDepthMulde: 'expert.dimensioning_results.selected_depth_mulde',
          selectedWidthMulde: 'expert.dimensioning_results.selected_width_mulde',
          requiredLengthOfInfiltrationDitch:
            'expert.dimensioning_results.required_length_of_infiltration_ditch',
          requiredInfiltrationDitchVolume:
            'expert.dimensioning_results.required_infiltration_ditch_volume',
          selectedNetoVolumeRigole: 'expert.dimensioning_results.selected_neto_volume_rigole',
          drainDurationRigole: 'expert.dimensioning_results.drain_duration_rigole',
          requiredTrenchVolume: 'expert.dimensioning_results.required_trench_volume_v_r_erf',
          selectedNetVolume: 'expert.dimensioning_results.selected_net_volume_v_r_net',
          emptyingTimeOfTrench:
            'expert.dimensioning_results.calculated_emptying_time_of_the_trench_t_e_r',
          troughWidthOnSole: 'expert.dimensioning_results.trough_width_on_the_sole_b_m_sole',
          length: 'expert.dimensioning_results.length_lr',
          requiredStorageVolume: 'expert.dimensioning_results.required_storage_volume_v_erf',
          requiredStorageVolumeTitle: 'expert.dimensioning_results.required_storage_volume',
          requiredRetentionVolume: 'expert.dimensioning_results.required_retention_volume',
          selectedRetentionVolume: 'expert.dimensioning_results.selected_retention_volume',
          netVolume: 'expert.dimensioning_results.neto_volume',
          actualStorageVolume: 'expert.dimensioning_results.actual_storage_volume',
          drainDurationDetention: 'expert.dimensioning_results.drain_duration_detention',
          drainDurationTe: 'expert.dimensioning_results.drain_duration_te',
          calculatedDrainDurationTe: 'expert.dimensioning_results.calculated_drain_duration_te',
          channelWidthOnSole: 'expert.dimensioning_results.channel_width_on_the_sole_b_m_sole',
          requiredDammingHeight: 'expert.dimensioning_results.required_damming_height_h_m_erf',
          requiredTroughVolume: 'expert.dimensioning_results.required_trough_volume_vm_erf',
          selectedTroughVolume: 'expert.dimensioning_results.selected_trough_volume_vm_gew',
          infiltrationAreaAs: 'expert.dimensioning_results.infiltration_area_as',
          infiltrationEffectiveArea: 'expert.dimensioning_results.infiltration_effective_area',
          durationOfStorage: 'expert.dimensioning_results.duration_of_storage',
          qsac: 'expert.dimensioning_results.qsac',
          drainDuration: 'expert.dimensioning_results.drain_duration',
          drainDurationOfRigoleTe: 'expert.dimensioning_results.drain_duration_of_rigole_te',
          drainDurationWarning:
            'expert.dimensioning_results.we_recommend_drain_durations_48h_further_measures_to_reduce_drain_time_should_be_considered',
          drainLengthWarning: 'expert.dimensioning_result.drain_length_warning',
          storageCoefficient: 'expert.dimensioning_results.storage_coefficient',
          storageCoefficientSr: 'expert.dimensioning_results.storage_coefficient_s_r',
          storageCoefficientOfRetentionSr:
            'expert.dimensioning_results.storage_coefficient_of_retention_sr',
          storageCoefficientOfFillingMaterial:
            'expert.dimensioning_results.storage_coefficient_of_the_filling_material_s_f',
          totalStorageCoefficientOfTrench:
            'expert.dimensioning_results.total_storage_coefficient_of_the_trench_s_r',
          proofOfDrainage: 'expert.dimensioning_results.proof_of_drainage',
          requiredDrainageRateOfInfiltrationPipe:
            'expert.dimensioning_results.required_drainage_rate_of_the_infiltration_pipe',
          existingDrainageYield: 'expert.dimensioning_results.existing_drainage_yield',
          minimumRequiredDrainageYieldWarning:
            'expert.dimensioning_result.minimum_required_drainage_yield_warning',
          resultingVolume: 'expert.dimensioning_results.resulting_volume',
          resultingInfiltrationVolume: 'expert.dimensioning_results.resulting_infiltration_volume',
          brutoVolume: 'expert.dimensioning_results.bruto_volume',
          brutoVolumeRigole: 'expert.dimensioning_results.bruto_volume_rigole',
          netoVolumeRigole: 'expert.dimensioning_results.neto_volume_rigole',
          grossVolumeVrGross: 'expert.dimensioning_results.gross_volume_v_r_gross',
          netVolumeVrNet: 'expert.dimensioning_results.net_volume_v_r_net',
          totalStorageCoefficientTrenchSr:
            'expert.dimensioning_results.total_storage_coefficient_of_the_trench_s_r',
          totalStorageCoefficientInfiltrationTrench:
            'expert.dimensioning_results.total_storage_coefficient_of_the_infiltration_trench_SRR,Rigole',
          trenchVolume: 'expert.dimensioning_results.trench_volume',
          requiredTrenchVolumeTitle: 'expert.dimensioning_results.required_trench_volume',
          chosenTrenchVolume: 'expert.dimensioning_results.chosen_trench_volume',
          chosenParametars: 'expert.dimensioning_results.chosen_parametars',
          selectedStowageHeightHmWt: 'expert.dimensioning_results.selected_stowage_height_h_m_wt',
          selectedWaterLevelHmGew: 'expert.dimensioning_results.selected_water_level_h_m_gew',
          angleOfRepose: 'expert.dimensioning_results.angle_of_repose',
          angleOfTrenchSlope: 'expert.dimensioning_results.angle_of_trench_slope',
          troughLength: 'expert.dimensioning_results.trough_length_lm',
          troughWidth: 'expert.dimensioning_results.trough_width_b_m',
          troughWidthOnBottom: 'expert.dimensioning_results.trough_width_on_the_bottom_b_m_bottom',
          blockageTime: 'expert.dimensioning_results.blockage_time',
          blockageTimeOfTrench: 'expert.dimensioning_results.blockage_time_of_trench',
          durationOfTheTroughImpoundmentTeM:
            'expert.dimensioning_results.duration_of_the_trough_impoundment_t_e_m',
          requiredStorageHeightHmErf: 'expert.dimensioning_results.required_storage_height_h_m_erf',
          rainfallDurationDm: 'expert.dimensioning_results.rainfall_duration_dm',
          precipitationIntensityRnM: 'expert.dimensioning_results.precipitation_intensity_r_n_m',
          precipitationHeightHnM: 'expert.dimensioning_results.precipitation_height_h_n_m',
          rainfallDurationDR: 'expert.dimensioning_results.rainfall_duration_d_r',
          precipitationRnR: 'expert.dimensioning_results.precipitation_r_n_r',
          precipitationHeightHnR: 'expert.dimensioning_results.precipitation_height_h_n_r',
          rainDurationDRigole: 'expert.dimensioning_results.rain_duration_d_rigole',
          rainDonationRnRigole: 'expert.dimensioning_results.rain_donation_r_nrigole',
          rainfallHeightHnRigole: 'expert.dimensioning_results.rainfall_height_r_nrigole',
          infiltrationEffectiveAreaAsM:
            'expert.dimensioning_results.infiltration_effective_area_a_s_m',
          versickerrateQsM: 'expert.dimensioning_results.versickerrate_qs_m',
          infiltrationEffectiveAreaAsR:
            'expert.dimensioning_results.infiltration_effective_area_a_s_r',
          seepageRateQsR: 'expert.dimensioning_results.seepage_rate_q_s_r',
          infiltrationEffectiveAreaAsRigole:
            'expert.dimensioning_results.infiltration_effective_area_asrigole',
          seepageRateQsRigole: 'expert.dimensioning_results.seepage_rate_qsrigole',
          // DWA-A 138 (04/2005) names of the same values.
          infiltrationEffectiveAreaAsMulde:
            'expert.dimensioning_results.infiltration_effective_area_asmulde',
          seepageRateQsMulde: 'expert.dimensioning_results.seepage_rate_qsmulde',
          requiredInfiltrationVolume: 'expert.dimensioning_results.required_infiltration_volume',
          infiltrationParametars: 'expert.dimensioning_results.infiltration_parametars',
          lengthRigole: 'expert.dimensioning_results.length_rigole',
          widthRigole: 'expert.dimensioning_results.width_rigole',
          heightRigole: 'expert.dimensioning_results.height_rigole',
          trenchLengthLr: 'expert.dimensioning_results.trench_length_l_r',
          trenchWidthBr: 'expert.dimensioning_results.trench_width_b_r',
          trenchHeightHr: 'expert.dimensioning_results.trench_height_h_r',
          drainRainDurationWarning: 'expert.dimensioning_result.drain_rain_duration_warning',
          infiltrationCapacityWarning:
            'expert.system_specifications.warning.infiltration_discharge_capacity_qs',
          relevantRainData: 'expert.dimensioning_results.relevant_rain_data',
          rainDuration: 'expert.dimensioning_results.rain_duration',
          rainDonationRn: 'expert.dimensioning_results.rain_donation_rn',
          rainfallHeightHn: 'expert.dimensioning_results.rainfall_height_hn',
          rainSeriesLimitWarning:
            'expert.dimensioning_results.the_required_volume_might_be_larger_than_calculated_as_rain_data_series_limit_was_reached',
          dimensionsInBlockGrid: 'expert.dimensioning_results.dimensions_in_block_grid',
          dimensionsInBlockGridLength:
            'expert.dimensioning_results.dimensions_in_block_grid_length',
          dimensionsInBlockGridWidth: 'expert.dimensioning_results.dimensions_in_block_grid_width',
          dimensionsInBlockGridHeight:
            'expert.dimensioning_results.dimensions_in_block_grid_height',
          lengthLr: 'expert.dimensioning_results.length_lr',
          widthWr: 'expert.dimensioning_results.width_wr',
          heightHr: 'expert.dimensioning_results.height_hr',
          seepageRate: 'expert.dimensioning_results.seepage_rate',
          infiltrationCapacity: 'expert.dimensioning_results.infiltration_capacity',
          drainSystem: 'expert.dimensioning_results.drain_system',
          trenchSystem: 'expert.dimensioning_results.trench_system',
          chartRainDuration: 'expert.dimensioning_results.chart.rain_duration',
          chartLength: 'expert.dimensioning_results.chart.infiltration_length',
          chartVolume: 'expert.dimensioning_results.chart.trench_volume',
          table: {
            permanentLevel: 'expert.dimensioning_results.table.permanent_level',
            rainDonation: 'expert.dimensioning_results.table.rain_donation',
            requiredInfiltrationVolume:
              'expert.dimensioning_results.table.required_infiltration_volume',
            requiredRetentionVolume: 'expert.dimensioning_results.table.required_retention_volume',
            requiredRetentionVolumeUnit:
              'expert.dimensioning_results.table.required_retention_volume_unit',
            requiredTrenchVolume: 'expert.dimensioning_results.table.required_trench_volume',
            requiredLength: 'expert.dimensioning_results.table.required_length',
            requiredLengthUnit: 'expert.dimensioning_results.table.required_length_unit',
            requiredInfiltrationLength:
              'expert.dimensioning_results.table.required_infiltration_length',
            requiredFloodVolume: 'expert.dimensioning_results.table.required_flood_volume',
            detentionPermanentLevelUnit:
              'expert.dimensioning_results.table.detention_permanent_level_unit',
            detentionRainDonationUnit:
              'expert.dimensioning_results.table.detention_rain_donation_unit',
          },
          dischargeTimeWarning: 'expert.dimensioning_result.discharge_time_warning',
        },
        switchToTreatment: {
          heading: 'expert.switch_to_treatment.optional_treatment_system',
          subHeading: 'expert.switch-to-treatment.do_you_want_to_add_treatment_to_your_system',
          quickAndEasySwitchToExpert: 'expert.switch-to-treatment.quick_and_easy_switch_to_expert',
          quickAndEasyOptionNoAdvice: 'expert.switch-to-treatment.quick_and_easy_option-no-advice',
        },
        switchToProofOfOverflow: {
          heading: 'expert.switch_to_proof_of_overflow.optional_proof_of_overflow',
          subHeading:
            'expert.switch_to_proof_of_overflow.do_you_want_to_add_an_overflow_verification',
          subHeadingFloodCheck:
            'expert.switch_to_proof_of_overflow.do_you_want_to_perform_a_flood_check',
        },
        proofOfOverflowOverview: 'expert.proof_of_overflow.proof_of_overflow_overview',
        proofOfOverflowDrainageSystemType: {
          heading: 'expert.proof_of_overflow.type_of_drainage_system',
          propertyDrainage: 'expert.proof_of_overflow.property_drainage',
          propertyDrainageTooltip: 'expert.proof_of_overflow.property_drainage_tooltip',
          publicDrainage: 'expert.proof_of_overflow.public_drainage',
          publicDrainageTooltip: 'expert.proof_of_overflow.public_drainage_tooltip',
        },
        proofOfOverflowAdditionalOverflowVolume: {
          heading: 'expert.additional_overflow_volume.arrangement_of_additional_overflow_volume',
          separateArrangement:
            'expert.additional_overflow_volume.separate_arrangement_of_overflow_volume',
          separateArrangementTooltip:
            'expert.additional_overflow_volume.separate_arrangement_of_overflow_volume_tooltip',
          combinationVolume: 'expert.additional_overflow_volume.combination_volume',
          combinationVolumeTooltip: 'expert.additional_overflow_volume.combination_volume_tooltip',
        },
        proofOfOverflowResults: {
          heading: 'expert.proof_of_overflow_results.results',
          freeDischargeIntoReceivingWater:
            'expert.proof_of_overflow_results.free_discharge_into_a_receiving_water_body',
          floodVolumeSeparatelyOnProperty:
            'expert.proof_of_overflow_results.flood_volume_must_be_provided_separately_on_the_property',
          floodVolume: 'expert.proof_of_overflow_results.flood_volume',
          governingVolumeEquation21:
            'expert.proof_of_overflow_results.governing_volume_according_to_equation_21',
          governingVolumeEquation20:
            'expert.proof_of_overflow_results.governing_volume_according_to_equation_20',
          nonStandAloneFloodVolume: 'expert.proof_of_overflow_results.non_stand_alone_flood_volume',
          rainDuration: 'expert.proof_of_overflow_results.rain_duration',
          rainDonation: 'expert.proof_of_overflow_results.rain_donation',
          rainfallHeight: 'expert.proof_of_overflow_results.rainfall_height',
          overallDimensions: 'expert.proof_of_overflow_results.overall_dimensions',
          overallDimensionsLength: 'expert.proof_of_overflow_results.overall_dimensions_length',
          overallDimensionsWidth: 'expert.proof_of_overflow_results.overall_dimensions_width',
          overallDimensionsHeight: 'expert.proof_of_overflow_results.overall_dimensions_height',
          overallDimensionsDepth: 'expert.proof_of_overflow_results.overall_dimensions_depth',
        },
        maxDischargeAtCompleteFillUp: {
          heading:
            'expert.discharge_of_ground_pipes.consider_discharge_of_ground_pipes_at_complete_fill_up_according_to_formula_21',
          headingTooltip:
            'expert.discharge_of_ground_pipes.consider_discharge_of_ground_pipes_at_complete_fill_up_according_to_formula_21_tooltip',
        },
        proofOfOverflowRainData: {
          heading:
            'expert.field_conditions.take_into_account_field_conditions_according_to_tab_4_(DWA-A_118)',
          headingTooltip:
            'expert.field_conditions.take_into_account_field_conditions_according_to_tab_4_(DWA-A_118)_tooltip',
          averageTerrainInclination: 'expert.field_conditions.average_terrain_inclination',
          noOptionTooltip: 'expert.field_conditions.no_option_tooltip',
          relevantRainDuration: 'expert.field_conditions.relevant_rain_duration',
          selectedRecurringInterval: 'expert.field_conditions.selected_recurring_interval',
        },
        proofOfOverflowConsiderLargerDrainageArea: {
          heading: 'expert.larger_drainage_area_option.larger_seepage_area',
          question: 'expert.proof_of_overflow_results.consider_the_larger_drainage_area',
          questionTooltip:
            'expert.proof_of_overflow_results.consider_the_larger_drainage_area_tooltip',
        },
        proofOfOverflowProtectionRequirement: {
          heading: 'expert.protection_requirement',
          normal: 'expert.protection_requirement.normal',
          normalTooltip: 'expert.protection_requirement.normal_tooltip',
          criticalInfrastructure: 'expert.protection_requirement.critical_infrastructure',
          criticalInfrastructureTooltip:
            'expert.protection_requirement.critical_infrastructure_tooltip',
          fractionOfCriticalAreas: 'expert.protection_requirement.fraction_of_critical_areas',
          fractionOfCriticalAreasTooltip:
            'expert.protection_requirement.fraction_of_critical_areas_tooltip',
          switchedNormalTooltip:
            'expert.switched_to_proof_of_overflow_protection_requirement.normal_tooltip',
          switchedCriticalInfrastructureTooltip:
            'expert.switched_to_proof_of_overflow_protection_requirement.critical_infrastructure_tooltip',
          switchedFractionOfCriticalAreasTooltip:
            'expert.switched_to_proof_of_overflow_protection_requirement.fraction_of_critical_areas_tooltip',
          publicDrainage: {
            introduction:
              'expert.switched_to_proof_of_overflow_protection_requirement.protection_requirement_following_DIN_EN_752',
            examplesOfDesignFrequencies:
              'expert.switched_to_proof_of_overflow_protection_requirement.examples_of_design_frequencies_of_channel_indicated_floods',
            impact: 'expert.switched_to_proof_of_overflow_protection_requirement.impact',
            exampleLocation:
              'expert.switched_to_proof_of_overflow_protection_requirement.example_location',
            annually: 'expert.switched_to_proof_of_overflow_protection_requirement.annualy',
            probabilityOfExceedance:
              'expert.switched_to_proof_of_overflow_protection_requirement.probability_of_exceedance_per_year',
            // Dynamic keys: the frequency abbreviation is appended, e.g. `....frequency_impact.hq2`
            frequencyImpact:
              'expert.switched_to_proof_of_overflow_protection_requirement.frequency_impact',
            frequencyExampleLocation:
              'expert.switched_to_proof_of_overflow_protection_requirement.frequency_example_location',
            note1:
              'expert.switched_to_proof_of_overflow_protection_requirement.flooding_frequency_table_note_1',
            note2:
              'expert.switched_to_proof_of_overflow_protection_requirement.flooding_frequency_table_note_2',
            note3:
              'expert.switched_to_proof_of_overflow_protection_requirement.flooding_frequency_table_note_3',
          },
        },
        continueToGpm: 'common.continue_to_gpm',
        materialList: 'common.material_list',
        waterType: {
          heading: 'expert.water_type.waterbodies',
          firstTableTitle: 'expert.water_type.water_type_first_table_title',
          secondTableTitle: 'expert.water_type.water_type_second_table_title',
          typeOfWater: 'expert.water_type.type_of_water',
          waterLocations: 'expert.water_type.water_locations',
          type: 'expert.water_type.type',
          points: 'expert.water_type.points',
          category: 'expert.water_type.category',
          typeName: 'expert.water_type',
          table1a: 'expert.water_type.table_1a',
          table1b: 'expert.water_type.table_1b',
          lubwAdditionTitle: 'expert.water_type.lubw_water_type_addition_title',
          lubwAdditionNote: 'expert.water_type.lubw_water_type_addition_note',
          lubwAdditionNoteFirst: 'expert.water_type.lubw_water_type_tables_notes_addition_note',
          lubwAdditionNoteSecond: 'expert.water_type.lubw_water_type_tables_notes_addition_note_2',
          notes: {
            dwaM153FirstTable: 'expert.water_type.dwam153_water_type_first_table_note',
            dwaM153SecondTableFirst: 'expert.water_type.dwam153_water_type_second_table_first_note',
            dwaM153SecondTableSecond:
              'expert.water_type.dwam153_water_type_second_table_second_note',
            lubwFirstTable: 'expert.water_type.lubw_water_type_first_table_note',
            lubwSecondTableFirst: 'expert.water_type.lubw_water_type_second_table_first_note',
            lubwSecondTableSecond: 'expert.water_type.lubw_water_type_second_table_second_note',
            lubwSecondTableThird: 'expert.water_type.lubw_water_type_second_table_third_note',
            lubwSecondTableFourth: 'expert.water_type.lubw_water_type_second_table_fourth_note',
          },
        },
        results: {
          chartNoReferentValue: 'expert.results.chart.graph_has_no_referent_value',
        },
      },
      gpm: {
        downloadCad: 'gpm.download_cad',
        downloadCadDownload: 'gpm.download_cad_download',
        holdAltToPanToCanvas: 'gpm.hold_alt_to_pan_to_canvas',
        saveAndContinueToMaterialList: 'gpm.save_and_continue_to_material_list',
        mobileFinish: 'gpm.mobile_finish',
        gpmMessage: 'gpm.gpm_message',
        copyLink: 'gpm.copy_link',
        noInletWarning: 'gpm.no_inlet_warning',
        lastInletDeleteWarning: 'gpm.last_inlet_delete_warning',
        errorPopUp: 'gpm.error_pop_up',
        errorPopUpContinueToMaterialList: 'gpm.error_pop_up_continue_to_material_list',
        treatmentSystemsLeftToPlace: 'gpm.treatment_systems_left_to_place',
        placeAdditionalControlShaft: 'gpm.place_additional_control_shaft',
        placeAdditionalControlShaftForTreatment: 'gpm.place_additional_control_shaft_for_treatment',
        rotationPopup: {
          message: 'gpm.rotation_popup.message',
          button: 'gpm.rotation_popup.button',
        },
        info: {
          infoSectionTitle: 'gpm.info.info_section_title',
          type: 'gpm.info.type',
          length: 'gpm.info.length',
          width: 'gpm.info.width',
          height: 'gpm.info.height',
          row: 'gpm.info.row',
          rows: 'gpm.info.rows',
          layer: 'gpm.info.layer',
          layers: 'gpm.info.layers',
          grossVolume: 'gpm.info.gross_volume',
          netVolume: 'gpm.info.net_volume',
          actualStorageVolume: 'gpm.info.actual_storage_volume',
        },
        products: {
          controlShafts: 'gpm.products.control_shafts',
          dischargeControlShafts: 'gpm.products.discharge_control_shafts',
          treatmentSystems: 'gpm.products.treatment_systems',
          inletsOutlets: 'gpm.products.inlets_outlets',
          aquaBackstop: 'gpm.products.aqua_backstop',
          adapter: 'gpm.products.stufenadapter',
        },
        toolbar: {
          zoomIn: 'gpm.toolbar.zoom_in',
          zoomOut: 'gpm.toolbar.zoom_out',
          zoomToFit: 'gpm.toolbar.zoom_to_fit',
          undo: 'gpm.toolbar.undo',
          redo: 'gpm.toolbar.redo',
          deleteProductTool: 'gpm.toolbar.delete_product_tool',
          rotateTool: 'gpm.toolbar.rotate_tool',
          canvasMoveTool: 'gpm.toolbar.canvas_move_tool',
          enterFullscreen: 'gpm.toolbar.enter_fullscreen',
          exitFullscreen: 'gpm.toolbar.exit_fullscreen',
        },
        msg: {
          gpmLoadFailed: 'gpm.msg.gpm_load_failed',
          addFailed: 'gpm.msg.add_failed',
          moveFailed: 'gpm.msg.move_failed',
          deleteFailed: 'gpm.msg.delete_failed',
          rotateFailed: 'gpm.msg.rotate_failed',
          undoFailed: 'gpm.msg.undo_failed',
          redoFailed: 'gpm.msg.redo_failed',
          treatmentSystemsWarning: 'gpm.msg.treatment_systems_warning',
          swtToRcOutletDiameterWarning: 'gpm.msg.swt_to_rc_outlet_diameter_warning',
        },
      },
    },
  },

  confirmModal: {
    modalNoButton: 'common.no',
    modalYesButton: 'common.yes',
    modalOkButton: 'common.ok',
  },
} as const;
